import React, { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import deLocale from '@fullcalendar/core/locales/de';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { query, orderByChild, equalTo ,getDatabase, ref, get, child, push, update, onValue, remove, set } from "firebase/database";
import { auth } from './firebase';
import Login from './Login';
// STORAGE SDK IMPORTS 👇
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import { getFunctions, httpsCallable } from 'firebase/functions';

// --- Helper functions ---

function formatGermanDateTime(date) {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hour = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year} ${hour}:${min}`;
}

function parseGermanDate(str) {
  if (!str || typeof str !== "string") return new Date(8640000000000000);
  const [d, t] = str.trim().split(" ");
  if (!d || !t) return new Date(8640000000000000);
  const [dd, mm, yyyy] = d.split(".").map(Number);
  const [HH, MM] = t.split(":").map(Number);
  if (!yyyy || !mm || !dd) return new Date(8640000000000000);
  return new Date(yyyy, (mm || 1) - 1, dd || 1, HH || 0, MM || 0, 0, 0);
}



const th = {
  textAlign: "left",
  padding: "8px 6px",
  borderBottom: "1px solid #eee",
  whiteSpace: "nowrap",
};

const td = {
  padding: "8px 6px",
  borderBottom: "1px solid #f3f4f6",
  verticalAlign: "top",
};


function formatImportantFeatures(raw) {
  if (!raw || typeof raw !== "string") return null;

  // Entfernt evtl. trailing "*"
  const cleaned = raw.trim().replace(/\*+$/, "");

  // Split nach den Labels
  const parts = {};
  const regex = /(Emotion|Prioritäten|Rückrufanleitung):\s*/g;

  // Wir bauen Segmente anhand der Label-Positionen
  const matches = [...cleaned.matchAll(regex)];
  if (matches.length === 0) return { fallback: cleaned };

  for (let i = 0; i < matches.length; i++) {
    const key = matches[i][1];
    const start = matches[i].index + matches[i][0].length;
    const end = i + 1 < matches.length ? matches[i + 1].index : cleaned.length;
    parts[key] = cleaned.slice(start, end).trim();
  }

  return parts;
}










function minutesToIsoDuration(minutes) {
  const m = parseInt(minutes, 10);
  const hours = Math.floor(m / 60);
  const mins = m % 60;
  let result = 'PT';
  if (hours) result += hours + 'H';
  if (mins) result += mins + 'M';
  if (!hours && !mins) result += '0M';
  return result;
}
function formatTime(date) {
  return date
    ? date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', hour12: false })
    : '';
}
function getDuration(event) {
  if (!event.start || !event.end) return 60;
  return (event.end.getTime() - event.start.getTime()) / 60000;
}
function FiveMinEvent({ eventColor, eventTitle }) {
  return (
    <div
      style={{
        backgroundColor: eventColor,
        color: '#fff',
        borderRadius: 6,
        fontSize: 8,
        fontWeight: 400,
        padding: '0px 4px 0px 4px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        boxShadow: '0 1px 2px rgba(0,0,0,0.07)',
        marginBottom: 1,
        marginTop: -1,
        lineHeight: 1,
        letterSpacing: 0.2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        textAlign: 'left',
        minHeight: 0
      }}
    >
      <span style={{ margin: 0, padding: 0 }}>{eventTitle}</span>
    </div>
  );
}

async function updateAppointment(appointmentId, data) {
  const db = getDatabase();
  const apptRef = ref(db, `appointments/${appointmentId}`);
  await update(apptRef, data);
}

function isValidGermanDateTime(str) {
  if (!str) return false;
  // Must be DD.MM.YYYY HH:MM, zero-padded, and valid ranges
  const re = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4} ([01][0-9]|2[0-3]):[0-5][0-9]$/;
  return re.test(str.trim());
}


function normalizeInternationalPhone(phone) {
  if (!phone) return "";
  // Remove spaces, +, dashes, etc.
  let num = String(phone).replace(/\D/g, '');

  // Remove leading '00' (international prefix)
  if (num.startsWith("00")) {
    num = num.substring(2);
  }

  // 🔴 German special case: "49017..." → "4917..."
  if (num.startsWith("49") && num[2] === "0") {
    num = "49" + num.slice(3);
  }

  return num;
}


// Checks for 11+ digits, no leading zero, only numbers
function isValidInternationalPhone(phone) {
  const num = normalizeInternationalPhone(phone);
  if (!num) return false;
  if (num.length < 11) return false;        // Minimum 11 digits (Germany, Spain, France, etc.)
  if (num.startsWith('0')) return false;    // No leading zero
  return /^\d+$/.test(num);                 // Digits only
}






// --- Modal Components ---

function VerfuegbarFuerModal({
  open,
  onClose,
  onConfirm,
  sidebarEvents = [],
  eventTitle = "",
  eventDateTime,  // <-- new
  duration: initialDuration = 5
}) {
  const [selectedType, setSelectedType] = useState(eventTitle || sidebarEvents[0]?.title || '');
  const [customTitle, setCustomTitle] = useState('');
  const [duration, setDuration] = useState(initialDuration);
  const [gesetzlich, setGesetzlich] = useState(true);
  const [privat, setPrivat] = useState(true);
  const [selbstzahler, setSelbstzahler] = useState(true);
  const [publishOption, setPublishOption] = useState("eigen");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setSelectedType(eventTitle || sidebarEvents[0]?.title || '');
      setCustomTitle('');
      setDuration(initialDuration);
      setGesetzlich(true);
      setPrivat(true);
      setSelbstzahler(true);
      setPublishOption("eigen");
      setError("");
    }
  }, [open, sidebarEvents, eventTitle, initialDuration]);

  const handleSubmit = () => {
    if (!gesetzlich && !privat && !selbstzahler) {
      setError("Bitte wähle mindestens eine Option unter 'Verfügbar für'.");
      return;
    }
    if (publishOption !== "eigen" && publishOption !== "oeffentlich") {
      setError("Bitte wähle eine Option unter 'Veröffentlichen für'.");
      return;
    }
    const title =
      selectedType === '__custom__'
        ? (customTitle || '').trim()
        : selectedType;
    if (!title || duration <= 0) {
      setError("Bitte Terminart und Dauer angeben.");
      return;
    }
    setError("");

    onConfirm(
      title,
      parseInt(duration, 10),
      true, // giveToPuzzle is always true in this version
      {
        verfuegbar_fuer: [
          ...(gesetzlich ? ["Gesetzlich"] : []),
          ...(privat ? ["Privat"] : []),
          ...(selbstzahler ? ["Selbstzahler"] : [])
        ].join(", "),
        audience: publishOption === "eigen"
          ? "Eigene Patient:Innen"
          : "Öffentlich (inkl. eigene Patient:Innen)"
      }
    );
  };

 


  if (!open) return null;
  return (
    <div style={{
      position: "fixed",
      zIndex: 9999,
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.18)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#fff", padding: 28, borderRadius: 10, minWidth: 290, boxShadow: "0 2px 16px rgba(0,0,0,0.15)"
      }}>
<div
  style={{
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 14,
    gap: 12 // space between the two
  }}
>
  <span style={{
    fontWeight: 600,
    fontSize: 18,
    color: "#222"
  }}>
    Termin an Puzzle Care übergeben
  </span>
  {eventDateTime && (
    <span style={{
      fontWeight: 500,
      fontSize: 16,
      color: "#222",
      opacity: 0.95
    }}>
      {eventDateTime}
    </span>
  )}
</div>


        {/* Terminart */}
        <div style={{ marginBottom: 10 }}>
          <label>
            Terminart:&nbsp;
            <select
              value={selectedType}
              style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
              onChange={e => setSelectedType(e.target.value)}
              disabled
            >
              {[...(sidebarEvents?.length ? sidebarEvents : [{title: eventTitle || "", duration: initialDuration, color: "#2563eb"}])].map(ev => (
                <option key={ev.title + ev.duration + ev.color} value={ev.title}>{ev.title}</option>
              ))}
            </select>
          </label>
        </div>

        {/* Dauer Eingabefeld */}
        <div style={{ marginBottom: 16 }}>
          <label>
            Dauer (Minuten):&nbsp;
            <input
              type="number"
              min={1}
              value={duration}
              onChange={e => setDuration(e.target.value)}
              style={{
                padding: "6px 8px",
                fontSize: 15,
                borderRadius: 6,
                border: "1px solid #ddd",
                width: 90
              }}
            />
          </label>
        </div>

        {/* Verfügbar für */}
        <div style={{ marginBottom: 18 }}>
          <div style={{ fontWeight: 500, marginBottom: 6 }}>Verfügbar für:</div>
          <label style={{ marginRight: 12 }}>
            <input type="checkbox" checked={gesetzlich} onChange={e => setGesetzlich(e.target.checked)} />
            &nbsp;Gesetzlich
          </label>
          <label style={{ marginRight: 12 }}>
            <input type="checkbox" checked={privat} onChange={e => setPrivat(e.target.checked)} />
            &nbsp;Privat
          </label>
          <label>
            <input type="checkbox" checked={selbstzahler} onChange={e => setSelbstzahler(e.target.checked)} />
            &nbsp;Selbstzahler
          </label>
        </div>

        {/* Veröffentlichen für */}
        <div style={{ marginBottom: 18 }}>
          <div style={{ fontWeight: 500, margin: "0 0 6px 0" }}>Veröffentlichen für:</div>
          <label style={{ display: 'block', marginBottom: 4 }}>
            <input
              type="radio"
              name="publishOption"
              value="eigen"
              checked={publishOption === "eigen"}
              onChange={() => setPublishOption("eigen")}
              style={{ marginRight: 6 }}
            />
            Eigene Patient:Innen (Bestandspatient:Innen)
          </label>
          <label style={{ display: 'block' }}>
            <input
              type="radio"
              name="publishOption"
              value="oeffentlich"
              checked={publishOption === "oeffentlich"}
              onChange={() => setPublishOption("oeffentlich")}
              style={{ marginRight: 6 }}
            />
            Öffentlich (inkl. Standort-/Behandler-/Praxisübergreifende Patient:Innen)
          </label>
        </div>

        {error && <div style={{ color: 'red', marginBottom: 10, fontSize: 14 }}>{error}</div>}
        <button
          onClick={handleSubmit}
          style={{
            background: "#5a55f4",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 22px",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: 15
          }}
        >
          An Puzzle Care übergeben
        </button>
        <button
          onClick={onClose}
          style={{
            marginLeft: 10,
            background: "#e5e7eb",
            color: "#222",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: 500,
            cursor: "pointer",
            fontSize: 15
          }}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}

function ManualEventModal({ open, onClose, onConfirm, sidebarEvents, eventDateTime  }) {
  const [selectedType, setSelectedType] = useState(sidebarEvents[0]?.title || '');
  const [customTitle, setCustomTitle] = useState('');
  const [duration, setDuration] = useState(5);
  const [error, setError] = useState("");
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [waitlistInsurance, setWaitlistInsurance] = useState("");
  const [addToWaitlist, setAddToWaitlist] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedType(sidebarEvents[0]?.title || '');
      setCustomTitle('');
      setDuration(5);
      setName('');
      setPhone('');
      setError("");
      setAddToWaitlist(false);      
      setWaitlistInsurance("");      
    }
  }, [open, sidebarEvents]);

  const handleSubmit = () => {
    const title =
      selectedType === '__custom__'
        ? (customTitle || '').trim()
        : selectedType;
  
    // Mandatory checks
    if (!title || duration <= 0 || !name.trim()) {
      setError("Bitte Patientenname ausfüllen.");
      return;
    }
  
    // Phone number check (use your isValidInternationalPhone function)
    if (!isValidInternationalPhone(phone)) {
      setError("Bitte eine gültige WhatsApp-Handynummer mit Ländervorwahl eingeben (z. B. 491701234567).");
      return;
    }
  
    if (addToWaitlist && !waitlistInsurance) {
      setError("Bitte Versicherungsart auswählen.");
      return;
    }
  
    setError("");
    onConfirm(
      title,
      parseInt(duration, 10),
      name,
      phone,
      addToWaitlist,
      waitlistInsurance
    );
  };
  
  

  if (!open) return null;
  return (
    <div style={{
      position: "fixed",
      zIndex: 9999,
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.18)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#fff", padding: 28, borderRadius: 10, minWidth: 290, boxShadow: "0 2px 16px rgba(0,0,0,0.15)"
      }}>

<div
  style={{
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 14,
    gap: 12
  }}
>
  <span style={{
    fontWeight: 600,
    fontSize: 18,
    color: "#222"
  }}>
    Termin an Puzzle Care übergeben
  </span>
  {eventDateTime && (
    <span style={{
      fontWeight: 600,
      fontSize: 16,
      color: "#222",
      opacity: 0.95
    }}>
      {eventDateTime}
    </span>
  )}
</div>



        {/* Terminart */}
        <div style={{ marginBottom: 10 }}>
          <label>
            Terminart:&nbsp;
            <select
              value={selectedType}
              style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
              onChange={e => setSelectedType(e.target.value)}
            >
              {sidebarEvents.map(ev => (
                <option key={ev.title + ev.duration + ev.color} value={ev.title}>{ev.title}</option>
              ))}
              <option value="__custom__">Andere Terminart (frei)</option>
            </select>
          </label>
        </div>
        {selectedType === '__custom__' && (
          <div style={{ marginBottom: 10 }}>
            <label>
              Eigene Terminart:&nbsp;
              <input
                type="text"
                value={customTitle}
                style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
                onChange={e => setCustomTitle(e.target.value)}
                autoFocus
              />
            </label>
          </div>
        )}

        {/* Dauer */}
        <div style={{ marginBottom: 16 }}>
          <label>
            Dauer (Minuten):&nbsp;
            <input
              type="number"
              min={1}
              value={duration}
              style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 90 }}
              onChange={e => setDuration(e.target.value)}
            />
          </label>
        </div>

{/* Name */}
<div style={{ marginBottom: 12 }}>
  <label>
    Patientenname:&nbsp;
    <input
      type="text"
      value={name}
      onChange={e => setName(e.target.value)}
      style={{
        padding: "6px 8px",
        fontSize: 15,
        borderRadius: 6,
        border: "1px solid #ddd",
        width: 180
      }}
    />
  </label>
</div>



        {/* Telefon */}
        <div style={{ marginBottom: 16 }}>
          <label>
            WhatsApp Telefonnummer (immer mit Ländervorwahl, z.B.49):&nbsp;
            <input
              type="text"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              style={{
                padding: "6px 8px",
                fontSize: 15,
                borderRadius: 6,
                border: "1px solid #ddd",
                width: 180
              }}
            />
          </label>
        </div>
        

        <div style={{ marginBottom: 14 }}>
  <label>
    <input
      type="checkbox"
      checked={addToWaitlist}
      disabled={selectedType === "__custom__" || selectedType === "Beliebige Terminart"}
      onChange={e => setAddToWaitlist(e.target.checked)}
      style={{ marginRight: 8 }}
    />
    <span
      style={{
        color: selectedType === "__custom__" ? "#b0b0b0" : "#345A46",
        fontWeight: 600
      }}
    >
      Patient zusätzlich auf die Praxis-Warteliste setzen. Einwilligung (z. B. telefonisch) liegt vor und wird hiermit dokumentiert.
    </span>
  </label>
</div>

{addToWaitlist && (
  <div style={{ marginBottom: 14 }}>
    <label>
      Versichert:&nbsp;
      <select
        value={waitlistInsurance}
        onChange={e => setWaitlistInsurance(e.target.value)}
        style={{
          padding: "6px 8px",
          fontSize: 15,
          borderRadius: 6,
          border: "1px solid #ddd",
          width: 180
        }}
      >
        <option value="">Bitte wählen...</option>
        <option value="Gesetzlich">Gesetzlich</option>
        <option value="Privat">Privat</option>
        <option value="Selbstzahler">Selbstzahler</option>
      </select>
    </label>
  </div>
)}

        {error && <div style={{ color: 'red', marginBottom: 10, fontSize: 14 }}>{error}</div>}
        <button
          onClick={handleSubmit}
          style={{
            background: "#5a55f4", color: "#fff", border: "none",
            borderRadius: 6, padding: "8px 20px", fontWeight: 600, cursor: "pointer", fontSize: 15
          }}
        >
          OK
        </button>
        <button
          onClick={onClose}
          style={{
            marginLeft: 10,
            background: "#e5e7eb",
            color: "#222",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: 500,
            cursor: "pointer",
            fontSize: 15
          }}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}





function WaitlistPatientModal({ open, onClose, onConfirm, sidebarEvents, eventDateTime  }) {
  const [selectedType, setSelectedType] = useState(sidebarEvents[0]?.title || '');
  const [customTitle, setCustomTitle] = useState('');
  const [duration, setDuration] = useState(5);
  const [error, setError] = useState("");
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [waitlistInsurance, setWaitlistInsurance] = useState("");
  const [addToWaitlist, setAddToWaitlist] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedType(sidebarEvents[0]?.title || '');
      setCustomTitle('');
      setDuration(5);
      setName('');
      setPhone('');
      setError("");
      setAddToWaitlist(false);      
      setWaitlistInsurance("");      
    }
  }, [open, sidebarEvents]);

  const handleSubmit = () => {
    const title = selectedType === '__custom__'
      ? (customTitle || '').trim()
      : selectedType;
  
    if (!title || duration <= 0 || !name.trim()) {
      setError("Bitte Patientenname ausfüllen.");
      return;
    }
    if (!isValidInternationalPhone(phone)) {
      setError("Bitte eine gültige WhatsApp-Handynummer mit Ländervorwahl eingeben (z. B. 491701234567).");
      return;
    }
    if (!waitlistInsurance) {
      setError("Bitte Versicherungsart auswählen.");
      return;
    }
  
    setError("");
    onConfirm(
      title,
      parseInt(duration, 10),
      name,
      phone,
      addToWaitlist,
      waitlistInsurance
    );
  };
  
  
  

  if (!open) return null;
  return (
    <div style={{
      position: "fixed",
      zIndex: 9999,
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.18)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#fff", padding: 28, borderRadius: 10, minWidth: 290, boxShadow: "0 2px 16px rgba(0,0,0,0.15)"
      }}>

<div
  style={{
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 14,
    gap: 12
  }}
>
  <span style={{
    fontWeight: 600,
    fontSize: 18,
    color: "#222"
  }}>
  Patienten ohne Termin auf die Warteliste setzen
  </span>
  {eventDateTime && (
    <span style={{
      fontWeight: 600,
      fontSize: 16,
      color: "#222",
      opacity: 0.95
    }}>
      {eventDateTime}
    </span>
  )}
</div>



        {/* Terminart */}
        <div style={{ marginBottom: 10 }}>
          <label>
            Terminart:&nbsp;
            <select
              value={selectedType}
              style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
              onChange={e => setSelectedType(e.target.value)}
            >
              {sidebarEvents.map(ev => (
                <option key={ev.title + ev.duration + ev.color} value={ev.title}>{ev.title}</option>
              ))}
              <option value="__custom__">Andere Terminart (frei)</option>
            </select>
          </label>
        </div>
        {selectedType === '__custom__' && (
          <div style={{ marginBottom: 10 }}>
            <label>
              Eigene Terminart:&nbsp;
              <input
                type="text"
                value={customTitle}
                style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
                onChange={e => setCustomTitle(e.target.value)}
                autoFocus
              />
            </label>
          </div>
        )}

        {/* Dauer */}
        <div style={{ marginBottom: 16 }}>
          <label>
            Dauer (Minuten):&nbsp;
            <input
              type="number"
              min={1}
              value={duration}
              style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 90 }}
              onChange={e => setDuration(e.target.value)}
            />
          </label>
        </div>

        {/* Name */}
        <div style={{ marginBottom: 12 }}>
          <label>
            Patientenname:&nbsp;
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              style={{
                padding: "6px 8px",
                fontSize: 15,
                borderRadius: 6,
                border: "1px solid #ddd",
                width: 180
              }}
            />
          </label>
        </div>

        {/* Telefon */}
        <div style={{ marginBottom: 16 }}>
          <label>
            WhatsApp Telefonnummer (immer mit Ländervorwahl, z.B.49):&nbsp;
            <input
              type="text"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              style={{
                padding: "6px 8px",
                fontSize: 15,
                borderRadius: 6,
                border: "1px solid #ddd",
                width: 180
              }}
            />
          </label>
        </div>
        

        <div style={{ marginBottom: 14 }}>
  <label>
    <input
      type="checkbox"
      checked={addToWaitlist}
      disabled={selectedType === "__custom__" || selectedType === "Beliebige Terminart"}
      onChange={e => setAddToWaitlist(e.target.checked)}
      style={{ marginRight: 8 }}
    />
    <span
      style={{
        color: selectedType === "__custom__" ? "#b0b0b0" : "#345A46",
        fontWeight: 600
      }}
    >
  Patient Standort- Behandler-/Praxisübergreifend und ohne Termin auf die Warteliste setzen. Einwilligung (z. B. telefonisch) liegt vor und wird hiermit dokumentiert.
  </span>
  </label>
</div>

{addToWaitlist && (
  <div style={{ marginBottom: 14 }}>
    <label>
      Versichert:&nbsp;
      <select
        value={waitlistInsurance}
        onChange={e => setWaitlistInsurance(e.target.value)}
        style={{
          padding: "6px 8px",
          fontSize: 15,
          borderRadius: 6,
          border: "1px solid #ddd",
          width: 180
        }}
      >
        <option value="">Bitte wählen...</option>
        <option value="Gesetzlich">Gesetzlich</option>
        <option value="Privat">Privat</option>
        <option value="Selbstzahler">Selbstzahler</option>
      </select>
    </label>
  </div>
)}

        {error && <div style={{ color: 'red', marginBottom: 10, fontSize: 14 }}>{error}</div>}
        <button
          onClick={handleSubmit}
          style={{
            background: "#5a55f4", color: "#fff", border: "none",
            borderRadius: 6, padding: "8px 20px", fontWeight: 600, cursor: "pointer", fontSize: 15
          }}
        >
          OK
        </button>
        <button
          onClick={onClose}
          style={{
            marginLeft: 10,
            background: "#e5e7eb",
            color: "#222",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: 500,
            cursor: "pointer",
            fontSize: 15
          }}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}



















// -------- ONLY THIS FUNCTION CHANGED --------
async function fetchDoctorConfig(doctorId) {
  // doctorId e.g. '-OPCpm1XYS_VMW9Bv95s'
  const configUrl = `https://firebasestorage.googleapis.com/v0/b/doctorscout-f11db.firebasestorage.app/o/calendarConfigs%2F${doctorId}.json?alt=media`;
  const resp = await fetch(configUrl);
  if (!resp.ok) throw new Error("Config not found for doctor: " + doctorId);
  return await resp.json();
}

export default function App() {
  const [user, setUser] = useState(null);
  const [sidebarEvents, setSidebarEvents] = useState(null); // loaded from config!
  const [configLoaded, setConfigLoaded] = useState(false);
  const [doctorName, setDoctorName] = useState(""); // <-- added
  const [doctorConfig, setDoctorConfig] = useState(null); // <-- new: full config object
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [selectedPatientInfo, setSelectedPatientInfo] = useState(null);
  const [events, setEvents] = useState([]);
  const [pendingDrop, setPendingDrop] = useState(null);
  const [showVerfModal, setShowVerfModal] = useState(false);
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualSelect, setManualSelect] = useState(null);
  const [editingNotes, setEditingNotes] = useState('');
const [editingEventId, setEditingEventId] = useState(null);
const [editedDateTime, setEditedDateTime] = useState("");
const [toast, setToast] = useState("");
const [editingPatientName, setEditingPatientName] = useState("");
const [editingPatientPhone, setEditingPatientPhone] = useState("");
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteTargetId, setDeleteTargetId] = useState(null);
const [deleteTargetStatus, setDeleteTargetStatus] = useState(null);
const [showManualModalWarteliste, setShowManualModalWarteliste] = useState(false);
const [showManualModalWartelisteWithDate, setShowManualModalWartelisteWithDate] = useState(false);
const [confirmPopups, setConfirmPopups] = useState([]); // Array of {id, time, etc}
const prevAppointmentsRef = useRef({});
const isFirstLoad = useRef(true); // <-- add this line
const [showPracticeModal, setShowPracticeModal] = useState(false);
const [practiceAppointments, setPracticeAppointments] = useState([]);
const [practiceLoading, setPracticeLoading] = useState(false);
const [practiceError, setPracticeError] = useState('');
const prevStatusRef = useRef(null);       // null until first snapshot processed
const poppedRef = useRef(new Set());
const [showQueueModal, setShowQueueModal] = useState(false);
const [queuePatients, setQueuePatients] = useState([]);
const [queueLoading, setQueueLoading] = useState(false);
const [queueError, setQueueError] = useState('');
const [showQueueDeleteModal, setShowQueueDeleteModal] = useState(false);
const [deleteTargetPatient, setDeleteTargetPatient] = useState(null);
const [anfragenLoading, setAnfragenLoading] = useState(false);
const [anfragenError, setAnfragenError] = useState('');
const [anfragenList, setAnfragenList] = useState([]);
const [isAnfragenOpen, setIsAnfragenOpen] = useState(false);
const [reminderLoading, setReminderLoading] = useState(false);
const [reminderError, setReminderError] = useState('');
const [reminderPatients, setReminderPatients] = useState([]);
const [showReminderModal, setShowReminderModal] = useState(false);








  // <<<<<<<<<<<<<<< ADDED for highlight & delete
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [selectedEventStatus, setSelectedEventStatus] = useState(null);

  const externalEventsRef = useRef(null);





function detectMatchedToConfirmed(newEvents) {
  // Build current status map
  const curr = {};
  newEvents.forEach(ev => { curr[ev.id] = ev.status; });

  // First snapshot after login: seed & bail (no popups for existing confirmed)
  if (prevStatusRef.current === null) {
    prevStatusRef.current = curr;
    return [];
  }

  const prev = prevStatusRef.current;
  const popups = [];

  for (const id in curr) {
    const before = prev[id];   // could be undefined (new appointment)
    const after  = curr[id];

    // Robust rule: any not-confirmed → confirmed flip
    if (after === "confirmed" && before !== "confirmed" && !poppedRef.current.has(id)) {
      const ev = newEvents.find(e => e.id === id);
      popups.push({ id, time: ev?.appointment_time });
      poppedRef.current.add(id);
    }
  }

  prevStatusRef.current = curr; // update for next comparison
  return popups;
}


  
  
  
  // On login, get doctor_id and load their config JSON
  useEffect(() => {
    if (!user) return;
    const db = getDatabase();
    get(child(ref(db), 'doctors')).then(snapshot => {
      let foundId = null;
      snapshot.forEach(childSnap => {
        const doc = childSnap.val();
        if (doc.phone === user.uid || doc.uid === user.uid) {
          foundId = childSnap.key;
        }
      });
      if (!foundId) throw new Error("Doctor config not found for this user.");
      fetchDoctorConfig(foundId).then(config => {
        setSidebarEvents(config.sidebarEvents);
        setDoctorName(config.doctorInfo?.name || "");
        setDoctorConfig(config); // <-- if you use this state
        setConfigLoaded(true);
      });
    });
  }, [user]);

  useEffect(() => {
    if (!user || !configLoaded || !sidebarEvents) return;

    const db = getDatabase();
    get(child(ref(db), 'doctors')).then(snapshot => {
      let foundId = null;
      snapshot.forEach(childSnap => {
        const doc = childSnap.val();
        if (doc.phone === user.uid || doc.uid === user.uid) {
          foundId = childSnap.key;
        }
      });
      if (!foundId) return;

      // Fetch appointments for this doctor
      const apptRef = ref(db, 'appointments');
      onValue(apptRef, async (snap) => {
        const apptList = [];
        const confirmedPatientIds = [];
      
        snap.forEach(childSnap => {
          const appt = childSnap.val();
          if (appt.doctor_id === foundId) {
            // Parse start time
            const [date, time] = appt.appointment_time.split(' ');
            const [d, m, y] = date.split('.').map(Number);
            const [h, min] = time.split(':').map(Number);
            const start = new Date(y, m - 1, d, h, min, 0, 0);
      
            const duration = appt.duration ? parseInt(appt.duration, 10) : 10;
            const end = new Date(start.getTime() + duration * 60000);
      
            // Find color
            let eventColor = '#2563eb';
            if (sidebarEvents && appt.termin_art) {
              const match = sidebarEvents.find(e => e.title === appt.termin_art);
              if (match && match.color) eventColor = match.color;
            }
            if (appt.status === "not_available") eventColor = "#111111";

              // Robust fallback: always include matched_patient, even if undefined
    const matched_patient = appt.matched_patient || null;
    if (appt.status === "confirmed" && matched_patient) {
      confirmedPatientIds.push(matched_patient);
    }
      
      
            apptList.push({
              id: childSnap.key,
              title: appt.is_beliebig ? "Beliebige Terminart" : appt.termin_art,
              start,
              end,
              allDay: false,
              color: appt.is_beliebig ? "#5C2925 " : (appt.color || eventColor),
              backgroundColor: appt.is_beliebig ? "#5C2925 " : (appt.backgroundColor || appt.color || eventColor),
              status: appt.status,
              appointment_time: appt.appointment_time,  
              matched_patient,
              notes: appt.notes || '',
              name: appt.name || '',        // fallback: stored directly
              phone: appt.phone || '',      // fallback: stored directly
            });
          }
        });
      
        // DEBUG
        console.log("apptList after fetch", apptList);
      
        // --- skip patient logic if no confirmed patients
        if (confirmedPatientIds.length === 0) {
          setEvents(apptList);  // <--- restore old behavior if none to fetch
          return;
        }
      
        const uniquePatientIds = Array.from(new Set(confirmedPatientIds));
        const patientInfoMap = {};
      
        try {
          await Promise.all(uniquePatientIds.map(async (patientId) => {
            const patientRef = ref(db, `patients/${patientId}`);
            const patientSnap = await get(patientRef);
            if (patientSnap.exists()) {
              const data = patientSnap.val();
              patientInfoMap[patientId] = {
                patientName: data.name,
                patientPhone: data.phone,
              };
            }
          }));
        } catch (err) {
          // Fallback: ignore patient fetch errors, still show calendar
          console.error("Error fetching patient info", err);
          setEvents(apptList);
          return;
        }
      
        // Attach patient info to relevant events
        const withPatientData = apptList.map(ev => {
          if (ev.status === "confirmed" && ev.matched_patient && patientInfoMap[ev.matched_patient]) {
            const p = patientInfoMap[ev.matched_patient];
            return {
              ...ev,
              patientName: patientInfoMap[ev.matched_patient].patientName,
              patientPhone: patientInfoMap[ev.matched_patient].patientPhone,
                  patientName: p?.patientName || ev.name || "",
      patientPhone: p?.patientPhone || ev.phone || ""
            };
          }
          return ev;
        });
      
    setEvents(withPatientData);

const newPopups = detectMatchedToConfirmed(withPatientData);
if (newPopups.length) {
  setConfirmPopups(prev => [...prev, ...newPopups]);
}


      });
         
    });
  }, [user, configLoaded, sidebarEvents]);

 

  useEffect(() => {
    if (!user || !sidebarEvents || !externalEventsRef.current) return;
    let draggable = new Draggable(externalEventsRef.current, {
      itemSelector: '.fc-event',
      eventData: function (eventEl) {
        const durationMin = parseInt(eventEl.getAttribute('data-duration'), 10);
        return {
          title: eventEl.getAttribute('data-title'),
          duration: minutesToIsoDuration(durationMin),
          color: eventEl.getAttribute('data-color'),
          backgroundColor: eventEl.getAttribute('data-color'),
          _sidebarDuration: durationMin
        };
      }
    });
    return () => {
      draggable.destroy && draggable.destroy();
    };
  }, [user, sidebarEvents, externalEventsRef]);

  // <<<<<<<<<<<<<<< ADDED: Keyboard ESC handler

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        if (showPatientModal) setShowPatientModal(false);
        if (showVerfModal) handleCloseVerfModal();
        if (showManualModal) handleCloseManualModal();
        if (showManualModalWarteliste) setShowManualModalWarteliste(false);
        if (showManualModalWartelisteWithDate) setShowManualModalWartelisteWithDate(false);
        if (showPracticeModal) setShowPracticeModal(false);
        if (showQueueModal) setShowQueueModal(false);   
        if (showReminderModal) setShowReminderModal(false);
              if (isAnfragenOpen) setIsAnfragenOpen(false); 



      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [
    showPatientModal, 
    showVerfModal, 
    showManualModalWarteliste, 
    showManualModal, 
    showManualModalWartelisteWithDate, // ← added!
    showPracticeModal,
     isAnfragenOpen,
     showReminderModal,
    showQueueModal // 

  ]);
  
  
  // <<<<<<<<<<<<<<< ADDED: Keyboard delete handler

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block delete if patient modal is open
      if (showPatientModal) return;
  
      // Block delete if any input or textarea is focused (like when typing in the modal)
      const tag = document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
  
      if ((e.key === 'Delete' || e.key === 'Backspace') && selectedEventId) {
        handleDeleteEvent(selectedEventId, selectedEventStatus);
        setSelectedEventId(null);
        setSelectedEventStatus(null);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedEventId, selectedEventStatus, showPatientModal]);
  
  // <<<<<<<<<<<<<<< ADDED: Delete function
  const handleDeleteEvent = async (eventId, eventStatus) => {
    if (eventStatus === "matched") {
      setToast("Dieser Termin kann nicht gelöscht werden, da Puzzle Care bereits einen Patienten gefunden hat.");
      setTimeout(() => setToast(""), 5000);
      return;
    }
  
    if (eventStatus === "confirmed") {
      // Open the custom modal, store event info
      setDeleteTargetId(eventId);
      setDeleteTargetStatus(eventStatus);
      setShowDeleteModal(true);
      return;
    }
  
    // For other statuses, proceed with actual deletion (we’ll make this function in step 3)
    await actuallyDeleteEvent(eventId);
  };



const deleteWaitlistOnlyPatient = async (queuePatient) => {
  try {
    const db = getDatabase();

    // 1. Determine patientId coming from getPracticeQueuePatients
    const patientId = queuePatient.id || queuePatient.patient_id;
    if (!patientId) {
      console.warn("deleteWaitlistOnlyPatient: no patientId on object", queuePatient);
      return;
    }

    // 2. Read the /patients node to get specialty, postal_code, priority, doctor_id
    const patientRef = ref(db, `patients/${patientId}`);
    const patientSnap = await get(patientRef);

    if (!patientSnap.exists()) {
      console.log(`deleteWaitlistOnlyPatient: patients/${patientId} does not exist, skipping /patients delete`);
      return;
    }

    const patient = patientSnap.val() || {};
    const specialty   = patient.specialty;
    const postalCode  = String(patient.postal_code || "");
    const postalPrefix = postalCode.slice(0, 2);
    const priority    = patient.priority;
    const doctorId    = patient.doctor_id;

    // 3. Delete from /patients
    await remove(patientRef);
    console.log(`🗑 Deleted patient ${patientId} from /patients`);

    // 4. Delete from /patients_waiting_queue, if we can derive the path
    if (specialty && postalPrefix.length >= 2 && priority !== undefined && doctorId) {
      const queuePath = `patients_waiting_queue/${specialty}/${postalPrefix}/priority_${priority}/${doctorId}/${patientId}`;
      await remove(ref(db, queuePath));
      console.log(`🗑 Deleted patient ${patientId} from queue path: ${queuePath}`);
    } else {
      console.warn(
        "deleteWaitlistOnlyPatient: missing data to build queue path",
        { specialty, postalPrefix, priority, doctorId, patientId }
      );
    }
  } catch (err) {
    console.error("deleteWaitlistOnlyPatient ERROR:", err);
    throw err; // rethrow so caller can show toast/alert
  }
};
















  const actuallyDeleteEvent = async (eventId) => {
    try {
      const db = getDatabase();
  
      // 1. Delete the appointment
      await remove(ref(db, `appointments/${eventId}`));
      setEvents(events => events.filter(ev => ev.id !== eventId));
  
      // 2. Find and delete related reminder/not_matched patients in /patients and the waiting queue
      const doctorId = doctorConfig?.doctorInfo?.doctor_id || "";
      const patientsQuery = query(
        ref(db, 'patients'),
        orderByChild('doctor_id'),
        equalTo(doctorId)
      );
      const patientsSnap = await get(patientsQuery);
      const promises = [];
  
      if (patientsSnap.exists()) {
        patientsSnap.forEach((childSnap) => {
          const promise = (async () => {
            const patient = childSnap.val();
            const patientId = childSnap.key;
  
            // Only delete patients linked to this appointment & in right status
            const deletableStatuses = ["reminder", "not_matched"];
            if (
              patient.original_appointment_id === eventId &&
              deletableStatuses.includes(patient.status)
            ) {
              // a. Delete from /patients
              await remove(ref(db, `patients/${patientId}`));
  
              // b. Delete from queue
              const specialty = patient.specialty;
              const postalCode = String(patient.postal_code || "");
              const postalPrefix = postalCode.slice(0, 2);
              const priority = patient.priority;
              const queueDoctorId = patient.doctor_id;
  
              if (
                !specialty ||
                postalPrefix.length < 2 ||
                priority === undefined ||
                !queueDoctorId
              )
                return;
  
              // Always use doctor_id in path!
              const queuePath = `/patients_waiting_queue/${specialty}/${postalPrefix}/priority_${priority}/${queueDoctorId}/${patientId}`;
  
              await remove(ref(db, queuePath));
  
              console.log(
                `🧹 Deleted patient ${patientId} (${patient.status}) from /patients and ${queuePath}`
              );
            }
          })();
  
          promises.push(promise);
        });
  
        await Promise.all(promises); // ✅ Wait for all deletes
      }
    } catch (err) {
      setToast("Fehler beim Löschen des Termins: " + (err.message || err));
      setTimeout(() => setToast(""), 2500);
    }
  };
  

  
  
  
  
  
  
  

  if (!user) {
    return <Login onLogin={setUser} />;
  }
  if (!configLoaded || !sidebarEvents) {
    return <div style={{ padding: 30 }}> Der Kalender wird für Sie individualisiert...</div>;
  }
  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
    setSidebarEvents(null);
    setConfigLoaded(false);
    setConfirmPopups([]);              // clear all popups!
    prevAppointmentsRef.current = {};  // reset status tracking
  };

  // ---- Calendar logic remains UNCHANGED ----
  const handleEventReceive = (info) => {
    setPendingDrop(info);
    setShowVerfModal(true);
  };

  const handleConfirmVerfModal = async (title, duration, giveToPuzzle, puzzleOptions) => {
    setShowVerfModal(false);
    const info = pendingDrop;
    if (!info || !doctorConfig) return;
  
    let start = info.event.start;
    let isAllDay = info.event.allDay;
    let end;
    const durationMin = duration || info.event.extendedProps._sidebarDuration || 60;
  
    if (isAllDay) {
      start = new Date(start);
      start.setHours(8, 0, 0, 0);
      end = new Date(start.getTime() + durationMin * 60000);
      isAllDay = false;
    } else {
      end = new Date(start.getTime() + durationMin * 60000);
    }
   
    
    const pad = (n) => n.toString().padStart(2, '0');
    const appointment_time =
      `${pad(start.getDate())}.${pad(start.getMonth() + 1)}.${start.getFullYear()} ${pad(start.getHours())}:${pad(start.getMinutes())}`;
      
      const db = getDatabase();

      // ---- BEGIN: Collision check ----
      const doctorId = doctorConfig?.doctorInfo?.doctor_id || "";
const doctorApptsQuery = query(
  ref(db, 'appointments'),
  orderByChild('doctor_id'),
  equalTo(doctorId)
);
const doctorApptsSnap = await get(doctorApptsQuery);
let conflict = false;
doctorApptsSnap.forEach(child => {
  const appt = child.val();
  if (appt.appointment_time === appointment_time) {
    conflict = true;
  }
});

      
      if (conflict) {
        const proceed = window.confirm(
          "An diesem Zeitpunkt existiert bereits ein anderer Termin. Wollen Sie fortfahren?"
        );
        if (!proceed) {
          setPendingDrop && setPendingDrop(null); // Only call if function exists in this context
          setShowVerfModal && setShowVerfModal(false);
          setShowManualModal && setShowManualModal(false);
          return;
        }
      }
      // ---- END: Collision check ----

      let termin_art;
      if (info.event.title === "Beliebige Terminart") {
        // Create a comma-separated string of all sidebar event titles except "Beliebige Terminart"
        termin_art = sidebarEvents
          .filter(ev => ev.title !== "Beliebige Terminart")
          .map(ev => ev.title)
          .join(", ");
      } else {
        termin_art = info.event.title;
      }
      
  
    // 👉 Color logic just like everywhere else:
    let color = "#111111";
    if (sidebarEvents && sidebarEvents.length > 0) {
      const sidebarMatch = sidebarEvents.find(e => e.title === termin_art);
      if (sidebarMatch) color = sidebarMatch.color;
    }
  
    const appointment = {
      appointment_time,
      doctor_id: doctorConfig?.doctorInfo?.doctor_id || "",
      matched_patient: "",
      postal_code: doctorConfig?.doctorInfo?.postal_code || "",
      rejectedPatients: [],
      response_locked: false,
      duration: durationMin,
      specialty: doctorConfig?.doctorInfo?.specialty || "",
      status: giveToPuzzle ? "available" : "not_available",
      termin_art,
      is_beliebig: info.event.title === "Beliebige Terminart",
      color: info.event.title === "Beliebige Terminart" ? "#5C2925" : color,
      backgroundColor: info.event.title === "Beliebige Terminart" ? "#5C2925" : color,
      color: color,
      backgroundColor: color,
      verfuegbar_fuer: puzzleOptions ? puzzleOptions.verfuegbar_fuer : "",
      audience: puzzleOptions ? puzzleOptions.audience : "",
    };
  
    try {
      const db = getDatabase();
      await push(ref(db, "appointments"), appointment);
      if (giveToPuzzle) {
        setToast("Termin erfolgreich an Puzzle Care übergeben!");
        setTimeout(() => setToast(""), 5000);
      }      
      }  
      catch (err) {
      alert("Fehler beim Speichern des Termins: " + (err.message || err));
    }
  
    setPendingDrop(null);
  };
  

  // ---- NEW: Write to database when handing over to Puzzle Care ----
  const handleHandOverToPuzzle = async (verfuegbar_fuer, publishOption) => {
    setShowVerfModal(false);
    const info = pendingDrop;
    if (!info || !doctorConfig) return;

    let start = info.event.start;
    let end;
    let isAllDay = info.event.allDay;
    const durationMin = info.event.extendedProps._sidebarDuration || 60;
    if (isAllDay) {
      start = new Date(start);
      start.setHours(8, 0, 0, 0);
      end = new Date(start.getTime() + durationMin * 60000);
      isAllDay = false;
    } else {
      end = new Date(start.getTime() + durationMin * 60000);
    }
    const pad = (n) => n.toString().padStart(2, '0');
    const appointment_time =
      `${pad(start.getDate())}.${pad(start.getMonth() + 1)}.${start.getFullYear()} ${pad(start.getHours())}:${pad(start.getMinutes())}`;
    const termin_art = info.event.title;

    const appointment = {
      appointment_time,
      doctor_id: doctorConfig?.doctorInfo?.doctor_id || "",
      matched_patient: "",
      postal_code: doctorConfig?.doctorInfo?.postal_code || "",
      rejectedPatients: [],
      response_locked: false,
      duration: durationMin,
      specialty: doctorConfig?.doctorInfo?.specialty || "",
      status: "available",
      termin_art,
      verfuegbar_fuer,
      audience: publishOption === "eigen"
        ? "Eigene Patient:Innen"
        : "Öffentlich (inkl. eigene Patient:Innen)"
    };

    try {
      const db = getDatabase();
      await push(ref(db, "appointments"), appointment);
      alert("Termin erfolgreich an Puzzle Care übergeben!");
    } catch (err) {
      alert("Fehler beim Übertragen des Termins: " + (err.message || err));
    }
    setPendingDrop(null);
  };

  const handleCloseVerfModal = () => {
    if (pendingDrop && pendingDrop.event) {
      pendingDrop.event.remove();
    }
    setShowVerfModal(false);
    setPendingDrop(null);
  };

  const handleDateSelect = (selectInfo) => {
    setManualSelect(selectInfo); // saves the slot info, including date/time
    setShowManualModalWartelisteWithDate(true); // open the correct modal!
  };
  
const openPracticeAvailModal = async () => {
  setPracticeLoading(true);
  setPracticeError('');

  try {
    const functions = getFunctions(undefined, 'europe-west1');
    const getPracticeAppointments = httpsCallable(functions, 'getPracticeAppointments');

    // Fetch practice-wide available appts
    const res = await getPracticeAppointments({ status: 'available' });
    let list = res?.data?.appointments || [];

    // Collect doctor_ids that came back without a name
    const missingIds = [...new Set(
      list.filter(a => !a.doctor_name && a.doctor_id).map(a => a.doctor_id)
    )];

    if (missingIds.length) {
      // One bulk read to map id -> name
      const db = getDatabase();
      const snap = await get(ref(db, 'doctors'));
      const allDocs = snap.val() || {};
      const nameById = {};

      missingIds.forEach(id => {
        const v = allDocs[id] || {};
        nameById[id] = v.name || v.displayName || v.doctorInfo?.name || id;
      });

      list = list.map(a => ({
        ...a,
        doctor_name: a.doctor_name || nameById[a.doctor_id] || a.doctor_id || 'Unbekannt'
      }));
    } else {
      // Nothing missing—still normalize
      list = list.map(a => ({
        ...a,
        doctor_name: a.doctor_name || a.doctor_id || 'Unbekannt'
      }));
    }

    setPracticeAppointments(list);
    setShowPracticeModal(true);
  } catch (err) {
    console.error('Praxis-Termine laden fehlgeschlagen:', err);
    setPracticeError(err?.message || 'Fehler beim Laden der Praxis-Termine.');
    setShowPracticeModal(true);
  } finally {
    setPracticeLoading(false);
  }
};


const openAnfragenModal = async () => {
  setAnfragenLoading(true);
  setAnfragenError("");

  try {
    const functions = getFunctions(undefined, "europe-west1");
    const getPracticeAnfragen = httpsCallable(
      functions,
      "getPracticeAnfragen"
    );

    const res = await getPracticeAnfragen({});
    const list = res?.data?.anfragen || [];

    setAnfragenList(list);
    setIsAnfragenOpen(true);
  } catch (err) {
    console.error("Anfragen laden fehlgeschlagen:", err);
    setAnfragenError(
      err?.message || "Fehler beim Laden der Anfragen."
    );
    setIsAnfragenOpen(true);
  } finally {
    setAnfragenLoading(false);
  }
};


const openReminderModal = async () => {
  setReminderLoading(true);
  setReminderError('');

  try {
    const functions = getFunctions(undefined, 'europe-west1');
    const getPracticeReminderPatients = httpsCallable(functions, 'getPracticeReminderPatients');

    const res = await getPracticeReminderPatients({});
    let list = res?.data?.patients || [];

    // (Optional) doctor_name auffüllen wie bei queue
    const missingIds = [...new Set(
      list.filter(p => !p.doctor_name && p.doctor_id).map(p => p.doctor_id)
    )];

    if (missingIds.length) {
      const db = getDatabase();
      const snap = await get(ref(db, 'doctors'));
      const allDocs = snap.val() || {};
      const nameById = {};
      missingIds.forEach(id => {
        const v = allDocs[id] || {};
        nameById[id] = v.name || v.displayName || v.doctorInfo?.name || id;
      });
      list = list.map(p => ({
        ...p,
        doctor_name: p.doctor_name || nameById[p.doctor_id] || p.doctor_id || 'Unbekannt'
      }));
    }

    setReminderPatients(list);
    setShowReminderModal(true);
  } catch (err) {
    console.error('Reminder-Patienten laden fehlgeschlagen:', err);
    setReminderError(err?.message || 'Fehler beim Laden der Reminder-Patienten.');
    setShowReminderModal(true);
  } finally {
    setReminderLoading(false);
  }
};












const openQueueModal = async () => {
  setQueueLoading(true);
  setQueueError('');

  try {
    const functions = getFunctions(undefined, 'europe-west1');
    const getPracticeQueuePatients = httpsCallable(functions, 'getPracticeQueuePatients');

    // Fetch patients in waiting queue (Cloud Function already filters to not_matched and doctor/practice scope)
    const res = await getPracticeQueuePatients({});
    let list = res?.data?.patients || [];

    // Map doctor_id -> doctor_name if missing
    const missingIds = [...new Set(
      list.filter(p => !p.doctor_name && p.doctor_id).map(p => p.doctor_id)
    )];

    if (missingIds.length) {
      const db = getDatabase();
      const snap = await get(ref(db, 'doctors'));
      const allDocs = snap.val() || {};
      const nameById = {};
      missingIds.forEach(id => {
        const v = allDocs[id] || {};
        nameById[id] = v.name || v.displayName || v.doctorInfo?.name || id;
      });
      list = list.map(p => ({
        ...p,
        doctor_name: p.doctor_name || nameById[p.doctor_id] || p.doctor_id || 'Unbekannt'
      }));
    } else {
      list = list.map(p => ({
        ...p,
        doctor_name: p.doctor_name || p.doctor_id || 'Unbekannt'
      }));
    }

    setQueuePatients(list);
    setShowQueueModal(true);
  } catch (err) {
    console.error('Warteliste laden fehlgeschlagen:', err);
    setQueueError(err?.message || 'Fehler beim Laden der Warteliste.');
    setShowQueueModal(true);
  } finally {
    setQueueLoading(false);
  }
};


















  function WaitlistPatientWithDateModal({
    open,
    onClose,
    onConfirmBehandler, // for Behandler-Warteliste (with or without checkbox)
    onConfirmStandort,  // for Standort-/Praxisübergreifende Warteliste
    onConfirm,          // fallback, if you use one handler
    sidebarEvents,
    initialDateTime,
  }) {
    const [selectedType, setSelectedType] = useState(sidebarEvents?.[0]?.title || '');
    const [customTitle, setCustomTitle] = useState('');
    const [duration, setDuration] = useState(5);
    const [error, setError] = useState("");
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [waitlistInsurance, setWaitlistInsurance] = useState("");
    const [showWaitlist, setShowWaitlist] = useState(false);
    const [waitlistType, setWaitlistType] = useState(""); // "behandler" or "standort"
    const [dateTime, setDateTime] = useState(initialDateTime || "");
  
    useEffect(() => {
      if (open) {
        setSelectedType(sidebarEvents?.[0]?.title || '');
        setCustomTitle('');
        setDuration(5);
        setName('');
        setPhone('');
        setError("");
        setShowWaitlist(false);
        setWaitlistType("");
        setWaitlistInsurance("");
        setDateTime(initialDateTime || getTodayDateTimeString());
      }
      // eslint-disable-next-line
    }, [open, sidebarEvents, initialDateTime]);
  
    function getTodayDateTimeString() {
      const now = new Date();
      const pad = n => n.toString().padStart(2, "0");
      return `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
    }
  
    // Validation
    const realTitle = selectedType === '__custom__' ? customTitle.trim() : selectedType;
    const phoneOk = isValidInternationalPhone(phone);
    const baseOk =
      !!realTitle &&
      !!name.trim() &&
      duration > 0 &&
      !!dateTime &&
      phoneOk;
  
    let okEnabled = false;
    if (!showWaitlist) {
      okEnabled = baseOk;
    } else if (showWaitlist && waitlistType && waitlistInsurance) {
      okEnabled = baseOk;
    }
  
    // -- Press OK logic --
    const handleSubmit = () => {
      if (!baseOk) {
        setError("Bitte alle Felder korrekt ausfüllen.");
        return;
      }
      if (!isValidGermanDateTime(dateTime)) {
        setError("Bitte Datum und Uhrzeit im Format TT.MM.JJJJ HH:MM eingeben!");
        return;
      }
      if (showWaitlist && !waitlistType) {
        setError("Bitte wählen Sie eine Warteliste aus.");
        return;
      }
      if (showWaitlist && !waitlistInsurance) {
        setError("Bitte Versicherungsart auswählen.");
        return;
      }
      setError("");
  
      // Pick handler (you can use either dual or single handler)
      if (showWaitlist) {
        if (waitlistType === "behandler" && onConfirmBehandler) {
          onConfirmBehandler(realTitle, parseInt(duration, 10), name, phone, true, waitlistInsurance, dateTime);
        } else if (waitlistType === "standort" && onConfirmStandort) {
          onConfirmStandort(realTitle, parseInt(duration, 10), name, phone, true, waitlistInsurance, dateTime);
        } else if (onConfirm) {
          onConfirm(realTitle, parseInt(duration, 10), name, phone, true, waitlistInsurance, dateTime, waitlistType);
        }
      } else {
        // Reminder path (checkbox NOT checked)
        if (onConfirmBehandler) {
          onConfirmBehandler(realTitle, parseInt(duration, 10), name, phone, false, "", dateTime);
        } else if (onConfirm) {
          onConfirm(realTitle, parseInt(duration, 10), name, phone, false, "", dateTime, "");
        }
      }
    };
  
    if (!open) return null;
    return (
      <div style={{
        position: "fixed",
        zIndex: 9999,
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.18)",
        display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        <div style={{
          background: "#fff", padding: 28, borderRadius: 10, minWidth: 290, boxShadow: "0 2px 16px rgba(0,0,0,0.15)"
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 600,
            fontSize: 18,
            marginBottom: 14,
            gap: 12
          }}>
            <span style={{ fontWeight: 600, fontSize: 18, color: "#222" }}>
            Termin vergeben und Patient auf die Warteliste setzen
            </span>
          </div>
          {/* Date & time input */}
          <div style={{ marginBottom: 10 }}>
            <label>
              Termin:&nbsp;
              <input
                type="text"
                value={dateTime}
                onChange={e => setDateTime(e.target.value)}
                style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 170 }}
                placeholder="TT.MM.JJJJ HH:MM"
              />
            </label>
          </div>
          {/* Terminart */}
          <div style={{ marginBottom: 10 }}>
            <label>
              Terminart:&nbsp;
              <select
                value={selectedType}
                style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
                onChange={e => setSelectedType(e.target.value)}
              >
                {sidebarEvents?.map(ev => (
                  <option key={ev.title + ev.duration + ev.color} value={ev.title}>{ev.title}</option>
                ))}
                <option value="__custom__">Andere Terminart (frei)</option>
              </select>
            </label>
          </div>
          {selectedType === '__custom__' && (
            <div style={{ marginBottom: 10 }}>
              <label>
                Eigene Terminart:&nbsp;
                <input
                  type="text"
                  value={customTitle}
                  style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 180 }}
                  onChange={e => setCustomTitle(e.target.value)}
                  autoFocus
                />
              </label>
            </div>
          )}
          {/* Dauer */}
          <div style={{ marginBottom: 16 }}>
            <label>
              Dauer (Minuten):&nbsp;
              <input
                type="number"
                min={1}
                value={duration}
                style={{ padding: "6px 8px", fontSize: 15, borderRadius: 6, border: "1px solid #ddd", width: 90 }}
                onChange={e => setDuration(e.target.value)}
              />
            </label>
          </div>
          {/* Name */}
          <div style={{ marginBottom: 12 }}>
            <label>
              Patientenname:&nbsp;
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                style={{
                  padding: "6px 8px",
                  fontSize: 15,
                  borderRadius: 6,
                  border: "1px solid #ddd",
                  width: 180
                }}
              />
            </label>
          </div>
          {/* Telefon */}
          <div style={{ marginBottom: 16 }}>
            <label>
              WhatsApp Telefonnummer (immer mit Ländervorwahl, z.B.49):&nbsp;
              <input
                type="text"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                style={{
                  padding: "6px 8px",
                  fontSize: 15,
                  borderRadius: 6,
                  border: "1px solid #ddd",
                  width: 180
                }}
              />
            </label>
          </div>
          {/* Warteliste Checkbox */}
          <div style={{ marginBottom: 14 }}>
            <label>
              <input
                type="checkbox"
                checked={showWaitlist}
                onChange={e => {
                  setShowWaitlist(e.target.checked);
                  if (!e.target.checked) {
                    setWaitlistType("");
                    setWaitlistInsurance("");
                  }
                }}
                style={{ marginRight: 8 }}
              />
              <span
                style={{
                  color: "#345A46",
                  fontWeight: 600
                }}
              >
                Patient zusätzlich auf die folgende Warteliste setzen. Einwilligung (z. B. telefonisch) liegt vor und wird hiermit dokumentiert.
              </span>
            </label>
          </div>
          {/* Radios */}
          {showWaitlist && (
            <div style={{ marginBottom: 14, marginLeft: 10 }}>
              <label style={{ display: "block", marginBottom: 4 }}>
                <input
                  type="radio"
                  name="waitlistType"
                  value="behandler"
                  checked={waitlistType === "behandler"}
                  onChange={() => setWaitlistType("behandler")}
                  style={{ marginRight: 6 }}
                />
                Behandler-Warteliste
              </label>
              <label style={{ display: "block" }}>
                <input
                  type="radio"
                  name="waitlistType"
                  value="standort"
                  checked={waitlistType === "standort"}
                  onChange={() => setWaitlistType("standort")}
                  style={{ marginRight: 6 }}
                />
                Standort-/Behandler-/Praxisübergreifende Warteliste
              </label>
            </div>
          )}
          {/* Versicherung */}
          {showWaitlist && waitlistType && (
            <div style={{ marginBottom: 14 }}>
              <label>
                Versichert:&nbsp;
                <select
                  value={waitlistInsurance}
                  onChange={e => setWaitlistInsurance(e.target.value)}
                  style={{
                    padding: "6px 8px",
                    fontSize: 15,
                    borderRadius: 6,
                    border: "1px solid #ddd",
                    width: 180
                  }}
                >
                  <option value="">Bitte wählen...</option>
                  <option value="Gesetzlich">Gesetzlich</option>
                  <option value="Privat">Privat</option>
                  <option value="Selbstzahler">Selbstzahler</option>
                </select>
              </label>
            </div>
          )}
  
          {error && <div style={{ color: 'red', marginBottom: 10, fontSize: 14 }}>{error}</div>}
          <button
            onClick={handleSubmit}
            disabled={!okEnabled}
            style={{
              background: okEnabled ? "#5a55f4" : "#b0b0b0",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "8px 20px",
              fontWeight: 600,
              cursor: okEnabled ? "pointer" : "not-allowed",
              fontSize: 15
            }}
          >
            OK
          </button>
          <button
            onClick={onClose}
            style={{
              marginLeft: 10,
              background: "#e5e7eb",
              color: "#222",
              border: "none",
              borderRadius: 6,
              padding: "8px 18px",
              fontWeight: 500,
              cursor: "pointer",
              fontSize: 15
            }}
          >
            Abbrechen
          </button>
        </div>
      </div>
    );
  }
  














  const handleConfirmManualModalWarteliste = async (
    title,
    duration,
    name,
    phone,
    addToWaitlist,
    waitlistInsurance
  ) => {
    // 1. Normalize phone number
    const normalizedPhone = normalizeInternationalPhone(phone);
    setShowManualModalWarteliste(false); // 2. Close the modal
  
    // 3. Validate
    if (!name || !normalizedPhone || !waitlistInsurance) {
      setToast("Bitte alle Felder ausfüllen!");
      setTimeout(() => setToast(""), 3000);
      return;
    }
  
    try {
      const db = getDatabase();
  
      // 4. Get current doctor_id (from doctorConfig)
      const currentDoctorId = doctorConfig?.doctorInfo?.doctor_id || "";
      if (!currentDoctorId) throw new Error("Kein Arzt angemeldet!");

      // 👇👇👇   DECLARE THESE VARIABLES!   👇👇👇
    let practice_id = null;
    const doctorIdsInPractice = [];

    // 👇  FETCH doctorsSnap!
    const doctorsSnap = await get(ref(db, 'doctors'));
  
     // Find this doctor's practice_id
doctorsSnap.forEach(childSnap => {
  const doc = childSnap.val();
  if (childSnap.key === currentDoctorId) {   // <-- Use the Firebase key
    practice_id = doc.practice_id;
  }
});

// Collect all doctor_ids with the same practice_id
doctorsSnap.forEach(childSnap => {
  const doc = childSnap.val();
  if (doc.practice_id && doc.practice_id === practice_id) {
    doctorIdsInPractice.push(childSnap.key); // <-- Use key, not doc.doctor_id
  }
});

  
if (!practice_id || doctorIdsInPractice.length === 0) {
    // Fallback: Single doctor, use only current doctor ID
    doctorIdsInPractice.length = 0;
    doctorIdsInPractice.push(currentDoctorId);
  }
  
  
      // 6. Build patient object with all doctor_ids (as array or comma string)
      const patientObj = {
        doctor_code: "",
        doctor_id: doctorIdsInPractice.join(","),
        name,
        phone: normalizedPhone,
        postal_code: doctorConfig?.doctorInfo?.postal_code || "",
        priority: 2,
        specialty: doctorConfig?.doctorInfo?.specialty || "",
        practice_id: practice_id, 
        ...(practice_id ? { practice_id } : {}), // ✅ Only include if it's valid
        terminart: title,
        versicherung: waitlistInsurance,
        waitlist_consent_timestamp: Date.now(),
      };
      await push(ref(db, "patients"), patientObj);
      
  
      // 8. Show toast
      setToast("Der Patient wurde ohne Termin auf die Warteliste gesetzt und ist für alle Ärzte/Therapeuten vermittelbar.");
      setTimeout(() => setToast(""), 5000);
  
      // 9. Reset modal state/UI if needed (fields should reset due to modal closing)
    } catch (err) {
      setToast("Fehler: " + (err.message || err));
      setTimeout(() => setToast(""), 3500);
    }
  };
  

  const handleConfirmManualModalWartelisteWithDate = async (
    title,
    duration,
    name,
    phone,
    addToWaitlist,
    waitlistInsurance,
    original_termin // date/time string from modal, editable
  ) => {
    setShowManualModalWartelisteWithDate(false);
  
    // Normalize phone number
    const normalizedPhone = normalizeInternationalPhone(phone);
  
    // Input validation (should also be done in modal, but double check)
    if (!name || !normalizedPhone || !waitlistInsurance || !original_termin) {
      setToast("Bitte alle Felder ausfüllen!");
      setTimeout(() => setToast(""), 3000);
      return;
    }
  
    try {
      const db = getDatabase();
  
      // Get current doctor_id from config
      const currentDoctorId = doctorConfig?.doctorInfo?.doctor_id || "";
      if (!currentDoctorId) throw new Error("Kein Arzt angemeldet!");
  
      // Get practice_id and all doctorIds in practice
      let practice_id = null;
      const doctorIdsInPractice = [];
      const doctorsSnap = await get(ref(db, 'doctors'));
  
      doctorsSnap.forEach(childSnap => {
        const doc = childSnap.val();
        if (childSnap.key === currentDoctorId) {
          practice_id = doc.practice_id;
        }
      });
      doctorsSnap.forEach(childSnap => {
        const doc = childSnap.val();
        if (doc.practice_id && doc.practice_id === practice_id) {
          doctorIdsInPractice.push(childSnap.key);
        }
      });
  
      if (!practice_id || doctorIdsInPractice.length === 0) {
        doctorIdsInPractice.length = 0;
        doctorIdsInPractice.push(currentDoctorId);
      }
  
      // 1. Create appointment (like "manual" calendar add with checkbox)
      // Prepare appointment object
      let color = "#111111";
      if (sidebarEvents?.length) {
        const sidebarMatch = sidebarEvents.find(e => e.title === title);
        if (sidebarMatch) color = sidebarMatch.color;
      }
      const appointment = {
        appointment_time: original_termin,
        doctor_id: currentDoctorId,
        matched_patient: "",
        postal_code: doctorConfig?.doctorInfo?.postal_code || "",
        rejectedPatients: [],
        response_locked: false,
        duration: duration,
        specialty: doctorConfig?.doctorInfo?.specialty || "",
        status: "not_available", // like checkbox checked
        termin_art: title,
        color: color,
        backgroundColor: color,
        name,
        phone: normalizedPhone,
      };
  
      // Write to /appointments and get appointment_id
      const apptRef = await push(ref(db, "appointments"), appointment);
      const appointment_id = apptRef.key;
  
      // 2. Create patient object (on waitlist)
      const patientObj = {
        doctor_code: "",
        doctor_id: doctorIdsInPractice.join(","),
        name,
        phone: normalizedPhone,
        postal_code: doctorConfig?.doctorInfo?.postal_code || "",
        priority: 2,
        specialty: doctorConfig?.doctorInfo?.specialty || "",
        practice_id: practice_id,
        terminart: title,
        versicherung: waitlistInsurance,
        waitlist_consent_timestamp: Date.now(),
        original_termin, // Save the editable date/time!
        original_appointment_id: appointment_id,
        status: "not_matched", // direct to waitlist!
      };
  
      await push(ref(db, "patients"), patientObj);
  
      setToast("Der Patient wurde auf die Warteliste gesetzt und ist für alle Ärzte/Therapeuten vermittelbar.");
      setTimeout(() => setToast(""), 5000);
  
    } catch (err) {
      setToast("Fehler: " + (err.message || err));
      setTimeout(() => setToast(""), 3500);
    }
  };
  





























  const handleConfirmManualModal = async (
    title,
    duration,
    name,
    phone,
    addToWaitlist,
    waitlistInsurance,
    dateTimeOverride // <-- this is the date string from your modal input!
  ) => {
    console.log("==== HANDLE CONFIRM MANUAL MODAL ====");
    console.log("[DEBUG] Funktion wurde aufgerufen");
    console.log("[DEBUG] user:", user);
    console.log("[DEBUG] doctorConfig:", doctorConfig);
  
    // Normalize phone number
    const normalizedPhone = normalizeInternationalPhone(phone);
  
    // Close modal (optional: you might want to do this after validations)
    setShowManualModal(false);
    setShowManualModalWartelisteWithDate(false);
  
    // Basic input check
    if (!title || !name || !normalizedPhone) {
      setToast("Bitte alle Felder ausfüllen!");
      setTimeout(() => setToast(""), 3000);
      return;
    }
  
    // Always use dateTimeOverride (from modal) if provided, else fallback to calendar slot
    let appointment_time = "";
    if (dateTimeOverride) {
      appointment_time = dateTimeOverride;
    } else if (manualSelect) {
      // Fallback: get time from calendar slot selection
      let start = new Date(manualSelect.startStr);
      let isAllDay = manualSelect.allDay;
      if (isAllDay) start.setHours(8, 0, 0, 0);
      const pad = (n) => n.toString().padStart(2, '0');
      appointment_time =
        `${pad(start.getDate())}.${pad(start.getMonth() + 1)}.${start.getFullYear()} ${pad(start.getHours())}:${pad(start.getMinutes())}`;
    } else {
      setToast("Fehler: Kein Terminzeitpunkt gewählt!");
      setTimeout(() => setToast(""), 3000);
      return;
    }
  
    // If waitlist is desired but no insurance is selected
    if (addToWaitlist && !waitlistInsurance) {
      setToast("Bitte Versicherungsart auswählen!");
      setTimeout(() => setToast(""), 3000);
      return;
    }
  
    try {
      const db = getDatabase();
      // Doctor info
      const doctorId = doctorConfig?.doctorInfo?.doctor_id || "";
      const color = (() => {
        const ev = sidebarEvents?.find(e => e.title === title);
        return ev ? ev.color : "#111111";
      })();
  
      // --- APPOINTMENT ---
      const appointment = {
        appointment_time,
        doctor_id: doctorId,
        matched_patient: "",
        postal_code: doctorConfig?.doctorInfo?.postal_code || "",
        rejectedPatients: [],
        response_locked: false,
        duration,
        specialty: doctorConfig?.doctorInfo?.specialty || "",
        status: addToWaitlist ? "not_available" : "reminder", 
        termin_art: title,
        color,
        backgroundColor: color,
        name,
        phone: normalizedPhone,
      };
      // Save appointment and get ID
      const apptRef = await push(ref(db, "appointments"), appointment);
      const appointment_id = apptRef.key;
  
      // --- PATIENT ---
      if (name && normalizedPhone) {
        const status = addToWaitlist ? "not_matched" : "reminder";
        const patientObj = {
          name,
          phone: normalizedPhone,
          doctor_code: doctorConfig?.doctorInfo?.doctor_code || "",
          doctor_id: doctorId,
          postal_code: doctorConfig?.doctorInfo?.postal_code || "",
          original_termin: appointment_time,
          priority: 0,
          specialty: doctorConfig?.doctorInfo?.specialty || "",
          terminart: title,
          versicherung: waitlistInsurance || "",
          original_appointment_id: appointment_id,
          status,
          waitlist_consent_timestamp: Date.now(),
        };
        await push(ref(db, "patients"), patientObj);
  
        if (status === "reminder") {
          setToast("Ihr Patient erhält eine Termin-Erinnerung, ist aber nicht in Ihrer Praxis-Warteliste.");
        } else {
          setToast("Der Patient wurde auf die Warteliste gesetzt und bekommt frühere Termine vorgeschlagen.");
        }
        setTimeout(() => setToast(""), 5000);
      }
    } catch (err) {
      setToast("Fehler beim Speichern des Termins: " + (err.message || err));
      setTimeout(() => setToast(""), 3500);
    }
    setManualSelect(null); // clean up calendar selection if any
  };
  



  
  
  

  const handleCloseManualModal = () => {
    setShowManualModal(false);
    setManualSelect(null);
  };

// ...above return, after other handler functions...
const handleEventDoubleClick = async (info) => {
  const event = info.event;
  const status = event.extendedProps.status;

  if (
    status === "confirmed" ||
    status === "matched" ||
    status === "available" ||
    status === "not_available"
  ) {
    const db = getDatabase();
    const eventRef = ref(db, `appointments/${event.id}`);
    const snap = await get(eventRef);
    const ev = snap.exists() ? snap.val() : {};

    let patientName = event.extendedProps.patientName || ev.name || "";
    let patientPhone = event.extendedProps.patientPhone || ev.phone || "";
    let notes = ev.notes || "";
    let appointment_time = ev.appointment_time || "";
    let termin_art = ev.termin_art || event.title || "";
    let statusVal = ev.status || event.extendedProps.status || "";

    // --- ONLY for confirmed appointments: fetch live if missing ---
    if (
      statusVal === "confirmed" &&
      ev.matched_patient &&
      (!patientName || !patientPhone)
    ) {
      try {
        const patSnap = await get(ref(db, `patients/${ev.matched_patient}`));
        if (patSnap.exists()) {
          const pat = patSnap.val();
          patientName = pat.name || patientName;
          patientPhone = pat.phone || patientPhone;
        }
      } catch (e) {
        // ignore fetch error
      }
    }

    setSelectedPatientInfo({
      name: patientName,
      phone: patientPhone,
      notes,
      termin_art,
      status: statusVal,
      start: event.start,
      end: event.end,
      appointment_time,
    });
    setEditingNotes(notes);
    setEditingEventId(event.id);
    setEditedDateTime(appointment_time);
    setEditingPatientName(patientName);
    setEditingPatientPhone(patientPhone);
    setShowPatientModal(true);
  }
};







  // <<<<<<<<<<<<<<< ADDED: eventClick handler for selection
  const handleEventClick = (info) => {
    setSelectedEventId(info.event.id);
    setSelectedEventStatus(info.event.extendedProps.status);
  };

  function renderEventContent(eventInfo) {
  const event = eventInfo.event;
  const viewType = eventInfo.view.type;
  const duration = getDuration(event);
  const status = event.extendedProps.status;

  // 1. Color override for special statuses
  let eventColor;
  if (status === "matched") {
    eventColor = "#7F7F7F";
  } else if (status === "confirmed") {
    eventColor = "#345A46";
  } else {
    eventColor =
      event.backgroundColor ||
      event.extendedProps.color ||
      event.color ||
      '#2563eb';
  }

  // Optional: border logic (keep or remove as you like)
  let borderWidth = 0, borderStyle = 'solid', borderColor = '';
  // Example: add a left border for "matched"
  if (status === "matched" || status === "available") {
    borderWidth = 4;
    borderStyle = 'dotted';
    borderColor = '#facc15';
  }

  // Highlight for selection (if you want)
  const isSelected = event.id === selectedEventId;

  // 5 min event special render
  if (duration === 5) {
    return <FiveMinEvent eventColor={eventColor} eventTitle={event.title} />;
  }

  // 10 min event
  if (duration === 10) {
    return (
      <div
        style={{
          position: 'relative',
          backgroundColor: eventColor,
          color: '#fff',
          borderRadius: 6,
          fontSize: 11,
          fontWeight: 500,
          padding: '2px 4px 0px 4px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          boxShadow: isSelected
            ? '0 0 0 2px #1d4ed8, 0 1px 2px rgba(0,0,0,0.07)'
            : '0 1px 2px rgba(0,0,0,0.07)',
          marginBottom: 1,
          marginTop: 1,
          lineHeight: 1.15,
          letterSpacing: 0.2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textAlign: 'left'
        }}
      >
        <span>{event.title}</span>
      </div>
    );
  }

  const eventStyle = {
    position: 'relative',
    backgroundColor: eventColor, // <-- THIS ENSURES FULL BACKGROUND OVERRIDE!
    color: '#fff',
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 400,
    padding: '7px 10px',
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    boxShadow: isSelected
      ? '0 0 0 2px #1d4ed8, 0 1px 2px rgba(0,0,0,0.07)'
      : '0 1px 2px rgba(0,0,0,0.07)',
    marginBottom: 1,
    marginTop: 1,
    lineHeight: 1.15,
    letterSpacing: 0.2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'left'
  };

  const timeStr =
    event.start && event.end
      ? `${formatTime(event.start)}–${formatTime(event.end)}`
      : '';


 



  // Multi-view logic stays as you have it!
  if (
    viewType === 'dayGridMonth' ||
    viewType === 'timeGridDay' ||
    viewType === 'timeGridWeek'
  ) {
    return (
      <div style={{ ...eventStyle, position: "relative" }}>
        {(borderWidth > 0) && (
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: borderWidth,
              background:
                borderStyle === 'dotted'
                  ? `repeating-linear-gradient(
                      to bottom,
                      ${borderColor},
                      ${borderColor} 4px,
                      transparent 4px,
                      transparent 8px
                    )`
                  : borderColor,
              borderRadius: '6px 0 0 6px',
              zIndex: 2,
            }}
          />
        )}
        {/* --- HERE: Add overlay for 'available' --- */}
        {status === "available" && (
          <div style={{
            position: "absolute",
            left: 0, top: 0, right: 0, bottom: 0,
            background: "rgba(255,255,255,0.28)", // Play with opacity (e.g. 0.18–0.42)
            borderRadius: 6,
            pointerEvents: "none",
            zIndex: 1
          }} />
        )}
        <span style={{ fontWeight: 400, fontSize: 11 }}>{timeStr}</span>
        <span style={{ fontWeight: 400, fontSize: 13 }}>{event.title}</span>
      </div>
    );
  }
  
  // Fallback (rarely used)
  return (
    <span style={{ fontSize: 13, fontWeight: 400 }}>{event.title}</span>
  );
}

const handleEventChange = async (changeInfo) => {
  const event = changeInfo.event;
  const eventStatus = event.extendedProps.status;
  const start = event.start;
  const end = event.end;
  const duration = (end - start) / 60000;

  // Detect if the start time was changed
  const originalStart = changeInfo.oldEvent ? changeInfo.oldEvent.start : null;
  const moved = originalStart && start && originalStart.getTime() !== start.getTime();

  if ((eventStatus === "matched" || eventStatus === "confirmed") && moved) {
    changeInfo.revert();
    alert("Verschieben von bestätigten oder gematchten Terminen ist nicht erlaubt.");
    return;
  }

  setEvents(prevEvents =>
    prevEvents.map(ev =>
      ev.id === event.id ? { ...ev, notes: editingNotes } : ev
    )
  );

  try {
    const db = getDatabase();
    const newAppointmentTime = `${start.getDate().toString().padStart(2, '0')}.${(start.getMonth() + 1).toString().padStart(2, '0')}.${start.getFullYear()} ${start.getHours().toString().padStart(2, '0')}:${start.getMinutes().toString().padStart(2, '0')}`;

    // Collision check
    console.log("[EventChange] Collision check on", newAppointmentTime);
    const allApptsSnap = await get(ref(db, 'appointments'));
    let conflict = false;
    allApptsSnap.forEach(child => {
      const appt = child.val();
      if (
        appt.doctor_id === (doctorConfig?.doctorInfo?.doctor_id || "") &&
        appt.appointment_time === newAppointmentTime &&
        child.key !== event.id
      ) {
        conflict = true;
      }
    });

    if (conflict) {
      const proceed = window.confirm(
        "An diesem Zeitpunkt existiert bereits ein anderer Termin. Wollen Sie fortfahren?"
      );
      if (!proceed) {
        changeInfo.revert();
        return;
      }
    }

    // --- Update the appointment itself ---
    console.log("[EventChange] Updating appointment", event.id, {appointment_time: newAppointmentTime, duration});
    await updateAppointment(event.id, {
      appointment_time: newAppointmentTime,
      duration: duration,
    });

    // --- Update all /patients entries with matching original_appointment_id ---
    const doctorId = doctorConfig?.doctorInfo?.doctor_id || "";
    console.log("[EventChange] Querying patients for doctorId:", doctorId);
    const patientsQuery = query(
      ref(db, 'patients'),
      orderByChild('doctor_id'),
      equalTo(doctorId)
    );
    const patientsSnap = await get(patientsQuery);

    let patientName = "", patientPhone = "";
    if (patientsSnap.exists()) {
      patientsSnap.forEach(child => {
        const patient = child.val();
        if (patient.original_appointment_id === event.id) {
          patientName = patient.name || "";
          patientPhone = patient.phone || "";
          console.log("[EventChange] Patient found:", child.key, patient.original_appointment_id, event.id, patient);

          // Debug doctor node and auth
          get(ref(db, `doctors/${patient.doctor_id}`)).then(doctorSnap => {
            console.log("[DEBUG] Doctor node data for", patient.doctor_id, doctorSnap.exists() ? doctorSnap.val() : null);
            if (doctorSnap.exists()) {
              console.log("[DEBUG] Doctor node UID:", doctorSnap.val().uid);
            }
            console.log("[DEBUG] Patient doctor_id:", patient.doctor_id);
            console.log("[DEBUG] Current auth.uid:", auth.currentUser?.uid);
          });

          // Log update
          console.log("Trying to update path:", `patients/${child.key}`, "with data:", { original_termin: newAppointmentTime });
          update(ref(db, `patients/${child.key}`), {
            original_termin: newAppointmentTime,
          }).then(() => {
            console.log("[EventChange] Patient update SUCCESS");
          }).catch(err => {
            console.error("[EventChange] Patient update ERROR", err);
          });
        }
      });
    }

    // --- Update only *your own* patients_waiting_queue entries ---
    try {
      // STEP 1: Get the specialty of the doctor from /doctors/${doctorId}
      const doctorRef = ref(db, `doctors/${doctorId}`);
      const doctorSnap = await get(doctorRef);
      const specialty = doctorSnap.exists() ? doctorSnap.val().specialty : null;
      if (!specialty) {
        console.error("No specialty found for doctorId", doctorId);
        return;
      }

      // STEP 2: Read only your own specialty branch in patients_waiting_queue
      const pwqRootRef = ref(db, `patients_waiting_queue/${specialty}`);
      const pwqSnap = await get(pwqRootRef);

      if (pwqSnap.exists()) {
        const pwq = pwqSnap.val();
        let foundQueueEntry = false;
        for (const prefixKey in pwq) {
          const prefixNode = pwq[prefixKey];
          for (const priorityKey in prefixNode) {
            const priorityNode = prefixNode[priorityKey];
            if (priorityNode[doctorId]) {
              const doctorNode = priorityNode[doctorId];
              for (const patientId in doctorNode) {
                const patientObj = doctorNode[patientId];
                if (patientObj.original_appointment_id === event.id) {   
                  foundQueueEntry = true;
                  const queuePath = `patients_waiting_queue/${specialty}/${prefixKey}/${priorityKey}/${doctorId}/${patientId}`;
                  console.log("[EventChange] Trying queue update at", queuePath, {
                    name: patientName,
                    phone: patientPhone,
                    original_termin: newAppointmentTime
                  });
                  try {
                    const nodeBeforeUpdate = await get(ref(db, queuePath));
                    console.log("[EventChange] Node at", queuePath, "before update:", nodeBeforeUpdate.val());
                    console.log("[EventChange] Auth UID:", auth.currentUser?.uid, "DoctorId:", doctorId);
                    // Print the *exact* queuePath string:
                    console.log("[EventChange] queuePath:", queuePath);

                    await update(
                      ref(db, queuePath),
                      {
                        name: patientName,
                        doctor_id: doctorId,  
                        phone: patientPhone,
                        original_termin: newAppointmentTime
                      }
                    );
                    console.log("[EventChange] Queue update SUCCESS at", queuePath);
                  } catch (err) {
                    console.error("[EventChange] Queue update ERROR at", queuePath, err);
                  }
                }
              }
            }
          }
        }
        if (!foundQueueEntry) {
          console.log("[EventChange] No matching queue entry found for event.id", event.id, "and doctorId", doctorId);
        }
      } else {
        console.log("[EventChange] No pwqSnap exists for specialty", specialty);
      }
    } catch (e) {
      console.error("[EventChange] Unexpected error in queue update block:", e);
    }

  } catch (err) {
    alert("Fehler beim Aktualisieren des Termins: " + (err.message || err));
  }
};



  

const handleEventResize = handleEventChange;

const eventStart = pendingDrop?.event?.start;
const eventDateTime =
  eventStart
    ? eventStart.toLocaleDateString("de-DE") +
      " " +
      eventStart.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit", hour12: false })
    : "";

    const manualEventDateTime =
    manualSelect?.start
      ? formatGermanDateTime(new Date(manualSelect.start))
      : "";
  
  

// // Event change over month

async function handlePatientModalSave() {
  if (!editingEventId) return;
  const db = getDatabase();

  // 1. Get the current appointment details (including doctor_id)
  const currentSnap = await get(ref(db, `appointments/${editingEventId}`));
  if (!currentSnap.exists()) return;
  const currentData = currentSnap.val();
  const doctorId = currentData.doctor_id;

  // Get the doctor's specialty (for queue path)
  const doctorSnap = await get(ref(db, `doctors/${doctorId}`));
  const specialty = doctorSnap.exists() ? doctorSnap.val().specialty : null;
  if (!specialty) {
    alert("Konnte die Fachrichtung des Arztes nicht ermitteln.");
    return;
  }

  // 2. Check if the time was actually changed (otherwise just update notes)
  const isTimeChanged = (editedDateTime && editedDateTime !== (currentData.appointment_time || ""));
  const newAppointmentTime = editedDateTime || currentData.appointment_time;

  if (!isValidGermanDateTime(editedDateTime)) {
    alert("Bitte Datum und Uhrzeit im Format TT.MM.JJJJ HH:MM eingeben!");
    return;
  }

  // 🚩 Block date/time change for matched/confirmed
  if (
    isTimeChanged &&
    (currentData.status === "matched" || currentData.status === "confirmed")
  ) {
    alert("Verschieben von bestätigten oder gematchten Terminen ist nicht erlaubt.");
    setShowPatientModal(false);
    return;
  }

  // 3. If time changed, check for conflicts
  if (isTimeChanged) {
    const doctorApptsQuery = query(
      ref(db, 'appointments'),
      orderByChild('doctor_id'),
      equalTo(doctorId)
    );
    const doctorApptsSnap = await get(doctorApptsQuery);
    let conflict = false;
    doctorApptsSnap.forEach(child => {
      const appt = child.val();
      if (
        child.key !== editingEventId &&
        appt.appointment_time === newAppointmentTime
      ) {
        conflict = true;
      }
    });

    if (conflict) {
      const proceed = window.confirm(
        "An diesem Zeitpunkt existiert bereits ein anderer Termin. Wollen Sie fortfahren?"
      );
      if (!proceed) {
        return;
      }
    }
  }

  // 4. Update appointment_time and notes in Firebase
  await update(ref(db, `appointments/${editingEventId}`), {
    appointment_time: newAppointmentTime,
    notes: editingNotes,
    name: editingPatientName,
    phone: editingPatientPhone
  });

  // --- after appointment update ---

  // Update all /patients entries with matching original_appointment_id
  const patientsQuery = query(
    ref(db, 'patients'),
    orderByChild('doctor_id'),
    equalTo(doctorId)
  );
  const patientsSnap = await get(patientsQuery);
  if (patientsSnap.exists()) {
    patientsSnap.forEach(child => {
      const patient = child.val();
      if (patient.original_appointment_id === editingEventId) {
        update(ref(db, `patients/${child.key}`), {
          name: editingPatientName,
          original_termin: newAppointmentTime,
          phone: editingPatientPhone
        });
      }
    });
  }

  // === Update only *your own* patients_waiting_queue entries, under specialty ===
  const specialtyRef = ref(db, `patients_waiting_queue/${specialty}`);
  const specialtySnap = await get(specialtyRef);
  if (specialtySnap.exists()) {
    const specialtyData = specialtySnap.val();
    for (const prefixKey in specialtyData) {
      const prefixNode = specialtyData[prefixKey];
      for (const priorityKey in prefixNode) {
        const priorityNode = prefixNode[priorityKey];
        if (priorityNode[doctorId]) {
          const doctorNode = priorityNode[doctorId];
          for (const patientId in doctorNode) {
            const patientObj = doctorNode[patientId];
            if (patientObj.original_appointment_id === editingEventId) {
              await update(
                ref(
                  db,
                  `patients_waiting_queue/${specialty}/${prefixKey}/${priorityKey}/${doctorId}/${patientId}`
                ),
                {
                  name: editingPatientName,
                  original_termin: newAppointmentTime,
                  phone: editingPatientPhone
                }
              );
            }
          }
        }
      }
    }
  }

  // Update local state
  setEvents(prevEvents =>
    prevEvents.map(ev =>
      ev.id === editingEventId
        ? {
            ...ev,
            appointment_time: newAppointmentTime,
            notes: editingNotes,
            name: editingPatientName,
            phone: editingPatientPhone,
            start: parseDate(newAppointmentTime),
            end: new Date(parseDate(newAppointmentTime).getTime() + (ev.end - ev.start))
          }
        : ev
    )
  );

  if (isTimeChanged) {
    setToast("Termin wurde verschoben!");
    setTimeout(() => setToast(""), 3000);
  }

  setShowPatientModal(false);
}

  


// Helper to parse German date-time string to JS Date
function parseDate(str) {
  // Example: "27.05.2025 13:30"
  const [date, time] = str.split(' ');
  const [day, month, year] = date.split('.').map(Number);
  const [hour, minute] = time.split(':').map(Number);
  return new Date(year, month - 1, day, hour, minute);
}

const editingBlocked = showPatientModal && selectedPatientInfo
? (selectedPatientInfo.status === "matched" || selectedPatientInfo.status === "confirmed")
: false;




    // This is return 


return (
  <>

{confirmPopups.map((popup) => (
  <div
    key={popup.id}
    style={{
      position: 'fixed',
      bottom: 32 + 72 * confirmPopups.findIndex(p => p.id === popup.id), // stack popups downward
      right: 32,
      background: '#303D4E',
      color: '#fff',
      padding: 16,
      borderRadius: 8,
      zIndex: 99999,
      minWidth: 220,
      boxShadow: "0 2px 16px rgba(0,0,0,0.14)",
      transition: "bottom 0.25s"
    }}
  >
    Puzzle Care hat eine neue Terminlücke gefüllt: {popup.time}
    <button
      style={{ marginLeft: 18 }}
      onClick={() =>
        setConfirmPopups(prev => prev.filter(p => p.id !== popup.id))
      }
    >
      Schließen
    </button>
  </div>
))}

    {/* Doctor Name Box */}
    {doctorName && (
      <div
        style={{
          position: "sticky",
          background: "transparent",
          boxShadow: "none",
          borderRadius: 0,
          top: 22,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 10001,
          background: "#5a55f4",
          color: "#fff",
            fontFamily: "'DM Sans', sans-serif",
          borderRadius: 6,
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          padding: "4px 12px",
          fontWeight: "bold",
          fontSize: 11,
          width: "fit-content",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "center",   // 👈 add this line
          whiteSpace: "nowrap",
          minHeight: 0
        }}
      >
        {doctorName}
      </div>
    )}
    {/* Logout button */}
    <div style={{
      position: "fixed",
      top: 22,
      right: 24,
      zIndex: 10001
    }}>
      <button
        onClick={handleLogout}
        style={{
          background: "#5a55f4",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          padding: "4px 8px",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: 10,
            fontFamily: "'DM Sans', sans-serif",
          boxShadow: "0 1px 6px rgba(0,0,0,0.08)"
        }}
      >
        Logout
      </button>
    </div>
    <VerfuegbarFuerModal
  open={showVerfModal}
  onClose={handleCloseVerfModal}
  onConfirm={handleConfirmVerfModal}
  onHandOver={handleHandOverToPuzzle}
  sidebarEvents={sidebarEvents}
  eventTitle={pendingDrop?.event?.title}
  eventDateTime={eventDateTime}           
  duration={pendingDrop?.event?.extendedProps?._sidebarDuration || 5}
/>

    <ManualEventModal
      open={showManualModal}
      onClose={handleCloseManualModal}
      onConfirm={handleConfirmManualModal}
      sidebarEvents={sidebarEvents}
      eventDateTime={manualEventDateTime}
    />

<WaitlistPatientModal
  open={showManualModalWarteliste}
  onClose={() => setShowManualModalWarteliste(false)}
  onConfirm={handleConfirmManualModalWarteliste}
  sidebarEvents={sidebarEvents}
  eventDateTime={null}
  // (you can add props if you want)
 />

<WaitlistPatientWithDateModal
  open={showManualModalWartelisteWithDate}
  onClose={() => setShowManualModalWartelisteWithDate(false)}
  onConfirmBehandler={handleConfirmManualModal}
  onConfirmStandort={handleConfirmManualModalWartelisteWithDate}
  sidebarEvents={sidebarEvents}
  initialDateTime={
    manualSelect?.start
      ? formatGermanDateTime(new Date(manualSelect.start))
      : ""
  }
/>





    {showPatientModal && selectedPatientInfo && (
      <div style={{
        position: "fixed",
        zIndex: 99999,
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "#fff",
          padding: 30,
          borderRadius: 10,
          minWidth: 290,
          boxShadow: "0 2px 16px rgba(0,0,0,0.22)",
          textAlign: "center"
        }}>


          <div style={{ fontWeight: 600, fontSize: 19, marginBottom: 16 }}>
            Patienteninfo
          </div>

          <div style={{ marginBottom: 12, fontWeight: 600, fontSize: 16 }}>
  Termin Zeitpunkt:
  <input
    type="text"
    value={editedDateTime}
    onChange={e => setEditedDateTime(e.target.value)}
    disabled={editingBlocked}
    style={{
      marginLeft: 10,
      padding: "6px 8px",
      fontSize: 16,
      borderRadius: 6,
      border: "1px solid #ddd",
      width: 180
    }}
  />
</div>




<div style={{ marginBottom: 14, fontSize: 16 }}>
  <strong>Patientenname:</strong>
  <input
    type="text"
    value={editingPatientName}
    onChange={e => setEditingPatientName(e.target.value)}
    disabled={editingBlocked}
    style={{
      marginLeft: 10,
      padding: "6px 8px",
      fontSize: 16,
      borderRadius: 6,
      border: "1px solid #ddd",
      width: 180
    }}
  />
</div>





<div style={{ marginBottom: 14, fontSize: 16 }}>
  <strong>WhatsApp Telefonnummer:</strong>
  <input
    type="text"
    value={editingPatientPhone}
    onChange={e => setEditingPatientPhone(e.target.value)}
    disabled={editingBlocked}
    style={{
      marginLeft: 10,
      padding: "6px 8px",
      fontSize: 16,
      borderRadius: 6,
      border: "1px solid #ddd",
      width: 180
    }}
  />
</div>


{/* --- ADD THIS --- */}
<div style={{ marginBottom: 14, fontSize: 16 }}>
  <strong>Terminart:</strong> {selectedPatientInfo.termin_art || ""}
</div>

          <div style={{ marginBottom: 14 }}>
            <strong>Notizen:</strong>
            <br />
            <textarea
              value={editingNotes}
              onChange={e => setEditingNotes(e.target.value)}
              style={{
                width: 230,
                minHeight: 60,
                borderRadius: 6,
                border: '1px solid #ddd',
                padding: 6,
                fontSize: 15,
                marginTop: 5,
              }}
            />
          </div>
          <button
            style={{
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "8px 20px",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: 15,
              marginRight: 10
            }}
            onClick={handlePatientModalSave}
          >
            Speichern
          </button>
          <button
            style={{
              background: "#e5e7eb",
              color: "#222",
              border: "none",
              borderRadius: 6,
              padding: "8px 20px",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: 15,
              marginLeft: 10
            }}
            onClick={() => setShowPatientModal(false)}
          >
            Schließen
          </button>
        </div>
      </div>
    )}

{showDeleteModal && (
  <div style={{
    position: "fixed",
    zIndex: 99999,
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.18)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}>
    <div style={{
      background: "#fff",
      padding: 28,
      borderRadius: 10,
      minWidth: 290,
      boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
      textAlign: "center"
    }}>
      <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 14, color: "#222" }}>
        Termin löschen bestätigen
      </div>
      <div style={{ fontSize: 15, marginBottom: 18 }}>
        Dieser Termin ist bereits <b>bestätigt</b>.<br />
        <span style={{ color: "#b91c1c", fontWeight: 500 }}>
          Bitte informieren Sie den Patieten telefonisch, falls Sie den Termin löschen möchten. 
        </span>
        <br /><br />
        Möchten Sie den Termin wirklich löschen?
      </div>
      <button
        onClick={async () => {
          await actuallyDeleteEvent(deleteTargetId);
          setShowDeleteModal(false);
          setDeleteTargetId(null);
          setDeleteTargetStatus(null);
        }}
        style={{
          background: "#d32f2f",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          padding: "8px 20px",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: 15,
          marginRight: 10
        }}
      >
        OK
      </button>
      <button
        onClick={() => {
          setShowDeleteModal(false);
          setDeleteTargetId(null);
          setDeleteTargetStatus(null);
        }}
        style={{
          background: "#e5e7eb",
          color: "#222",
          border: "none",
          borderRadius: 6,
          padding: "8px 18px",
          fontWeight: 500,
          cursor: "pointer",
          fontSize: 15,
          marginLeft: 10
        }}
      >
        Abbrechen
      </button>
    </div>
  </div>
)}

{showQueueDeleteModal && deleteTargetPatient && (
  <div style={{
    position: "fixed", zIndex: 100000,
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.18)",
    display: "flex", alignItems: "center", justifyContent: "center"
  }}>
    <div style={{
      background: "#fff", padding: 28, borderRadius: 10, minWidth: 290,
      boxShadow: "0 2px 16px rgba(0,0,0,0.15)", textAlign: "center"
    }}>
      <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 14, color: "#222" }}>
        Patient löschen bestätigen
      </div>
      <div style={{ fontSize: 15, marginBottom: 18 }}>
        Soll der Patient <b>{deleteTargetPatient.name}</b> wirklich gelöscht werden?
      </div>

 <button
  onClick={async () => {
    try {
      const patientId = deleteTargetPatient.id || deleteTargetPatient.patient_id;

      if (deleteTargetPatient.original_appointment_id) {
        // Patient WITH appointment -> use existing helper
        await actuallyDeleteEvent(deleteTargetPatient.original_appointment_id);
      } else {
        // WAITLIST-ONLY PATIENT -> call Cloud Function with Admin privileges
        const functions = getFunctions(undefined, "europe-west1");
        const deleteWaitlistOnlyPatient = httpsCallable(
          functions,
          "deleteWaitlistOnlyPatient"
        );
        await deleteWaitlistOnlyPatient({ patientId });
      }

      // Update UI + close modal
      setQueuePatients((prev) =>
        prev.filter(
          (q) =>
            (q.id || q.patient_id) !== (deleteTargetPatient.id || deleteTargetPatient.patient_id)
        )
      );
      setShowQueueDeleteModal(false);
      setShowQueueModal(false);
    } catch (err) {
      console.error("Fehler beim Löschen:", err);
      alert("Fehler beim Löschen des Patienten.");
    }
  }}
  style={{
    background: "#d32f2f",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    padding: "8px 20px",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: 15,
    marginRight: 10
  }}
>
  OK
</button>


      <button
        onClick={() => {
          setShowQueueDeleteModal(false);
          setDeleteTargetPatient(null);
        }}
        style={{
          background: "#e5e7eb", color: "#222", border: "none",
          borderRadius: 6, padding: "8px 18px", fontWeight: 500,
          cursor: "pointer", fontSize: 15, marginLeft: 10
        }}
      >
        Abbrechen
      </button>
    </div>
  </div>
)}







{showPracticeModal && (
  <div
    style={{
      position: "fixed",
      zIndex: 99999,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(2, 6, 23, 0.42)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18,
  fontFamily: "'Inter', sans-serif",
    }}
    onClick={() => setShowPracticeModal(false)}
  >
    <div
      style={{
        background: "rgba(255,255,255,0.96)",
        borderRadius: 16,
        width: "92vw",
        maxWidth: 1200,
        maxHeight: "82vh",
        overflow: "auto",
        boxShadow: "0 18px 60px rgba(0,0,0,0.28)",
        border: "1px solid rgba(15, 23, 42, 0.08)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          background:  "rgba(255,255,255,0.96)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(0, 0, 0, 1)",
          padding: "16px 18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <div style={{ fontWeight: 900, fontSize: 18, color: "#0f172a" }}>
            Gruppen-weit verfügbare Termine 🧩📆
          </div>
          <div style={{ fontSize: 12, color: "rgba(15,23,42,0.65)" }}>
            Alle verfügbaren Termine innerhalb der Praxisgruppe.
          </div>
        </div>

        <button
          onClick={() => setShowPracticeModal(false)}
          style={{
           background: "#eef2ff",
            color: "#1f2937",
            border: "1px solid rgba(15,23,42,0.10)",
            borderRadius: 10,
            padding: "8px 12px",
            fontWeight: 800,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          ✕ Schließen
        </button>
      </div>

      {/* BODY */}
      <div style={{ padding: 18 }}>
        {practiceLoading && (
          <div
            style={{
              padding: 12,
              borderRadius: 12,
              background: "rgba(15,23,42,0.04)",
              border: "1px solid rgba(15,23,42,0.06)",
              fontSize: 14,
              color: "rgba(15,23,42,0.8)",
            }}
          >
            Lade…
          </div>
        )}

        {practiceError && (
          <div
            style={{
              padding: 12,
              borderRadius: 12,
              background: "rgba(239, 68, 68, 0.08)",
              border: "1px solid rgba(239, 68, 68, 0.18)",
              fontSize: 14,
              color: "#991b1b",
            }}
          >
            {practiceError}
          </div>
        )}

        {!practiceLoading && !practiceError && (
          practiceAppointments.length === 0 ? (
            <div
              style={{
                padding: 12,
                borderRadius: 12,
                background: "rgba(15,23,42,0.04)",
                border: "1px solid rgba(15,23,42,0.06)",
                fontSize: 14,
                color: "rgba(15,23,42,0.75)",
              }}
            >
              Keine verfügbaren Termine vorhanden.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* ONE HEADER ROW (like ❓ modal) */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.2fr 1.1fr 1fr 0.7fr 0.8fr",
                  gap: 12,
                  padding: "10px 14px",
                  borderRadius: 12,
                  background: "rgba(15,23,42,0.04)",
                  border: "1px solid rgba(15, 23, 42, 0.06)",
                  fontSize: 11,
                  fontWeight: 900,
                  color: "rgba(0, 0, 0, 1)",
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                }}
              >
                <div>Datum & Uhrzeit</div>
                <div>Arzt/Therapeut</div>
                <div>Terminart</div>
                <div>Dauer</div>
                <div>Status</div>
              </div>

              {/* ROWS (no per-card labels) */}
              {practiceAppointments.map((a) => (
                <div
                  key={a.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1.2fr 1.1fr 1fr 0.7fr 0.8fr",
                    gap: 12,
                    alignItems: "center",
                    padding: 14,
                    borderRadius: 14,
                    background: "rgba(255,255,255,0.92)",
                    border: "1px solid rgba(15, 23, 42, 0.08)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ fontSize: 14, color: "#0f172a" }}>
                    {a.appointment_time}
                  </div>

                  <div style={{ fontSize: 14, color: "rgba(15,23,42,0.85)" }}>
                    {a.doctor_name || a.doctor_id}
                  </div>

                  <div style={{ fontSize: 14, color: "rgba(15,23,42,0.85)" }}>
                    {a.termin_art || "-"}
                  </div>

                  <div style={{ fontSize: 14, color: "rgba(15,23,42,0.85)" }}>
                    {a.duration ? `${a.duration} Min` : "-"}
                  </div>

                  <div>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        fontSize: 12,
                        fontWeight: 900,
                        padding: "6px 10px",
                        borderRadius: 999,
                        background:
                          (a.status || "").toLowerCase() === "available"
                            ? "rgba(16, 185, 129, 0.16)"
                            : "rgba(15, 23, 42, 0.08)",
                        color:
                          (a.status || "").toLowerCase() === "available"
                            ? "#065f46"
                            : "rgba(15,23,42,0.75)",
                        border:
                          (a.status || "").toLowerCase() === "available"
                            ? "1px solid rgba(16, 185, 129, 0.22)"
                            : "1px solid rgba(15, 23, 42, 0.10)",
                      }}
                    >
                      {(a.status || "-").toString()}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  </div>
)}





{showReminderModal && (
  <div
    style={{
      position: "fixed",
      zIndex: 99999,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(15, 23, 42, 0.38)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18,
      fontFamily: "'DM Sans', sans-serif",
    }}
    onClick={() => setShowReminderModal(false)}
  >
    <div
      style={{
        background: "rgba(255,255,255,0.96)",
        border: "1px solid rgba(15,23,42,0.10)",
        borderRadius: 16,
        width: "94vw",
        maxWidth: 1180,
        maxHeight: "82vh",
        overflow: "auto",
        boxShadow: "0 16px 44px rgba(0,0,0,0.22)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(15,23,42,0.12)",
          padding: "16px 18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <div style={{ fontWeight: 900, fontSize: 18 }}>
            Patientenerinnerungen ⏰
          </div>
          <div style={{ fontSize: 12, color: "rgba(15,23,42,0.65)" }}>
            Praxisweit · sortiert nach Terminzeitpunkt
          </div>
        </div>

        <button
          onClick={() => setShowReminderModal(false)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "#eef2ff",
            color: "#1f2937",
            border: "1px solid rgba(15,23,42,0.10)",
            borderRadius: 999,
            padding: "8px 12px",
            fontWeight: 800,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          ✕ Schließen
        </button>
      </div>

      {/* BODY */}
      <div style={{ padding: 18 }}>
        {reminderLoading && (
          <div style={{ padding: 10, fontSize: 14, color: "rgba(15,23,42,0.75)" }}>
            Lade…
          </div>
        )}

        {reminderError && (
          <div style={{ padding: 10, fontSize: 14, color: "#b91c1c" }}>
            {reminderError}
          </div>
        )}

        {!reminderLoading && !reminderError && (
          reminderPatients.length === 0 ? (
            <div style={{ padding: 10, fontSize: 14, color: "rgba(15,23,42,0.75)" }}>
              Keine Patientenerinnerungen vorhanden.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* SINGLE HEADER ROW */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.1fr 1.1fr 1fr 1.2fr 0.6fr",
                  gap: 12,
                  padding: "10px 14px",
                  borderRadius: 12,
                  background: "rgba(15,23,42,0.04)",
                  border: "1px solid rgba(15,23,42,0.06)",
                  fontSize: 11,
                  fontWeight: 900,
                  color: "rgba(0,0,0,1)",
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                }}
              >
                <div>Patient</div>
                <div>Telefon</div>
                <div>Terminart</div>
                <div>Terminzeitpunkt</div>
                <div style={{ textAlign: "center" }}>Aktionen</div>
              </div>

              {/* ROWS */}
              {reminderPatients.map((p) => (
                <div
                  key={p.id || p.patient_id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1.1fr 1.1fr 1fr 1.2fr 0.6fr",
                    gap: 12,
                    alignItems: "center",
                    padding: 14,
                    borderRadius: 14,
                    background: "rgba(255,255,255,0.92)",
                    border: "1px solid rgba(15,23,42,0.08)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ fontSize: 14 }}>{p.name || "-"}</div>
                  <div style={{ fontSize: 14 }}>{p.phone || "-"}</div>
                  <div style={{ fontSize: 14 }}>{p.terminart || "-"}</div>
                  <div style={{ fontSize: 14 }}>{p.original_termin || "-"}</div>

                  <div style={{ textAlign: "center" }}>
                    <button
                      onClick={async () => {
                        try {
                          const apptId = p.original_appointment_id;
                          if (!apptId) {
                            alert("Fehler: original_appointment_id fehlt.");
                            return;
                          }

                          await actuallyDeleteEvent(apptId);

                          setReminderPatients((prev) =>
                            prev.filter(
                              (x) =>
                                (x.id || x.patient_id) !== (p.id || p.patient_id)
                            )
                          );

                          setShowReminderModal(false);
                        } catch (err) {
                          console.error("Fehler beim Löschen:", err);
                          alert("Fehler beim Löschen des Reminder-Patienten.");
                        }
                      }}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 12,
                        border: "1px solid rgba(185,28,28,0.18)",
                        background: "rgba(185,28,28,0.10)",
                        color: "#b91c1c",
                        fontWeight: 900,
                        cursor: "pointer",
                        boxShadow: "0 6px 16px rgba(185,28,28,0.10)",
                      }}
                      title="Patientenerinnerung löschen"
                    >
                      ❌
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  </div>
)}











{isAnfragenOpen && (
  <div
    style={{
      position: "fixed",
      zIndex: 99999,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(15, 23, 42, 0.45)", // darker + modern
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18,
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
    }}
    onClick={() => setIsAnfragenOpen(false)}
  >
    <div
      style={{
        background: "#fff",
        padding: 22,
        borderRadius: 16,
        minWidth: 360,
        maxWidth: 1380,
        width: "94vw",
        maxHeight: "84vh",
        overflow: "hidden", // header stays fixed, body scrolls
        boxShadow: "0 24px 60px rgba(2, 6, 23, 0.25)",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        fontFamily: "'DM Sans', sans-serif",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          paddingBottom: 12,
          borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(90, 85, 244, 0.12)",
              color: "#5a55f4",
              fontWeight: 900,
            }}
              title="Anfragen"
          >
            ❓ 
          </div>

          <div>
            <div style={{ fontWeight: 800, fontSize: 18, lineHeight: 1.1 }}>
               Puzzle Anfragemanagement
            </div>
            <div style={{ fontSize: 12, color: "rgba(15,23,42,0.55)", marginTop: 2 }}>
              Alle offenen Anfragen
            </div>
          </div>
        </div>

        <button
          onClick={() => setIsAnfragenOpen(false)}
          style={{
            background: "#eef2ff",
            color: "#1f2937",
            border: "1px solid rgba(15,23,42,0.10)",
            borderRadius: 10,
            padding: "8px 12px",
            fontWeight: 700,
            cursor: "pointer",
            fontSize: 13,
            boxShadow: "0 1px 0 rgba(0,0,0,0.03)",
          }}
        >
          ✕ Schließen
        </button>
      </div>

      {/* BODY */}
      <div style={{ paddingTop: 14, overflow: "auto", maxHeight: "calc(84vh - 78px)" }}>
        {/* STATES */}
        {anfragenLoading && (
          <div
            style={{
              padding: 14,
              fontSize: 14,
              background: "rgba(15, 23, 42, 0.03)",
              border: "1px solid rgba(15, 23, 42, 0.08)",
              borderRadius: 12,
            }}
          >
            Lade Anfragen…
          </div>
        )}

        {anfragenError && (
          <div
            style={{
              padding: 14,
              fontSize: 14,
              color: "#b91c1c",
              background: "rgba(185, 28, 28, 0.06)",
              border: "1px solid rgba(185, 28, 28, 0.18)",
              borderRadius: 12,
            }}
          >
            {anfragenError}
          </div>
        )}

        {!anfragenLoading && !anfragenError && (
          anfragenList.length === 0 ? (
            <div
              style={{
                padding: 16,
                fontSize: 14,
                background: "rgba(15, 23, 42, 0.03)",
                border: "1px dashed rgba(15, 23, 42, 0.18)",
                borderRadius: 12,
                color: "rgba(15,23,42,0.7)",
              }}
            >
              Keine offenen Anfragen vorhanden.
            </div>
          ) : (
            <div style={{ width: "100%", overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: 0,
                  fontSize: 14,
                  tableLayout: "fixed",
                  minWidth: 1120, // wider so Aktionen stays visible more often
                }}
              >
                <thead>
                  <tr>
                    <th style={{ ...th, width: 150, position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                      Name
                    </th>
                    <th style={{ ...th, width: 130, position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                      Telefon
                    </th>
                    <th style={{ ...th, width: 170, position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                      E-Mail
                    </th>
                    <th style={{ ...th, width: 180, position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                      Anfrage
                    </th>
                    <th style={{ ...th, width: 360, position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                      Rückruf-Tipps
                    </th>
                    <th style={{ ...th, width: 110, position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                      Status
                    </th>
                    <th
                      style={{
                        ...th,
                        width: 110,
                        textAlign: "center",
                        position: "sticky",
                        top: 0,
                        background: "#fff",
                        zIndex: 2,
                      }}
                    >
                      Aktionen
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {anfragenList.map((a, idx) => (
                    <tr
                      key={a.id}
                      style={{
                        background: idx % 2 === 0 ? "rgba(15, 23, 42, 0.015)" : "#fff",
                      }}
                    >
                      <td style={{ ...td, whiteSpace: "normal", wordBreak: "break-word" }}>
                        {a.user_name || "-"}
                      </td>

                      <td style={{ ...td, whiteSpace: "normal", wordBreak: "break-word" }}>
                        {a.user_phone || "-"}
                      </td>

                      <td style={{ ...td, whiteSpace: "normal", wordBreak: "break-word", color: "rgba(15,23,42,0.75)" }}>
                        {a.user_email || "-"}
                      </td>

                      <td style={{ ...td, whiteSpace: "normal", wordBreak: "break-word" }}>
                        {a.user_request || "-"}
                      </td>

                      <td style={td}>
                        {(() => {
                          const f = formatImportantFeatures(a.user_important_features);
                          if (!f) return "-";
                          if (f.fallback) return f.fallback;

                          return (
                            <div style={{ lineHeight: 1.4 }}>
                              {f.Emotion && (
                                <div style={{ marginBottom: 6 }}>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      fontSize: 12,
                                      fontWeight: 800,
                                      padding: "2px 8px",
                                      borderRadius: 999,
                                      background: "rgba(244, 63, 94, 0.10)",
                                      color: "#9f1239",
                                      marginRight: 8,
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Emotion
                                  </span>
                                  <span>{f.Emotion}</span>
                                </div>
                              )}

                              {f["Prioritäten"] && (
                                <div style={{ marginBottom: 6 }}>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      fontSize: 12,
                                      fontWeight: 800,
                                      padding: "2px 8px",
                                      borderRadius: 999,
                                      background: "rgba(245, 158, 11, 0.14)",
                                      color: "#92400e",
                                      marginRight: 8,
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Prioritäten
                                  </span>
                                  <span>{f["Prioritäten"]}</span>
                                </div>
                              )}

                              {f.Rückrufanleitung && (
                                <div>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      fontSize: 12,
                                      fontWeight: 800,
                                      padding: "2px 8px",
                                      borderRadius: 999,
                                      background: "rgba(90, 85, 244, 0.14)",
                                      color: "#3730a3",
                                      marginRight: 8,
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Rückrufanleitung
                                  </span>
                                  <span>{f.Rückrufanleitung}</span>
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </td>

                      <td style={td}>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontSize: 12,
                            fontWeight: 800,
                            padding: "4px 10px",
                            borderRadius: 999,
                            background:
                              (a.status || "").toLowerCase() === "offen"
                                ? "rgba(16, 185, 129, 0.14)"
                                : "rgba(15, 23, 42, 0.08)",
                            color:
                              (a.status || "").toLowerCase() === "offen"
                                ? "#065f46"
                                : "rgba(15,23,42,0.75)",
                          }}
                        >
                          {(a.status || "-").toString()}
                        </span>
                      </td>

                      <td style={{ ...td, textAlign: "center" }}>
                        <button
                          style={{
                            background: "rgba(16, 185, 129, 0.12)",
                            border: "1px solid rgba(16, 185, 129, 0.28)",
                            cursor: "pointer",
                            fontSize: 14,
                            fontWeight: 900,
                            padding: "8px 10px",
                            borderRadius: 10,
                          }}
                          title="Als erledigt markieren"
onClick={async () => {
  try {
    const functions = getFunctions(undefined, "europe-west1");
    const deleteAnfrage = httpsCallable(functions, "deleteAnfrage");
    await deleteAnfrage({ anfrageId: a.id });

    setAnfragenList((prev) => prev.filter((x) => x.id !== a.id));
  } catch (err) {
    console.error("deleteAnfrage failed:", err);
    alert("Fehler beim Löschen der Anfrage.");
  }
}}
                        >
                          ✅
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}
      </div>
    </div>
  </div>
)}





{showQueueModal && (
  <div
    style={{
      position: "fixed",
      zIndex: 99999,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(2, 6, 23, 0.42)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18,
      fontFamily: "'DM Sans', sans-serif",
    }}
    onClick={() => setShowQueueModal(false)}
  >
    <div
      style={{
        background: "rgba(255,255,255,0.96)",
        borderRadius: 16,
        width: "92vw",
        maxWidth: 1200,
        maxHeight: "82vh",
        overflow: "auto",
        boxShadow: "0 18px 60px rgba(0,0,0,0.28)",
        border: "1px solid rgba(15, 23, 42, 0.08)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(0, 0, 0, 1)",
          padding: "16px 18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <div style={{ fontWeight: 900, fontSize: 18, color: "#0f172a" }}>
            Ihre freien Wartelisten-Patienten 🧩⏰
          </div>
          <div style={{ fontSize: 12, color: "rgba(15,23,42,0.65)" }}>
            Alle Patienten in der Warteliste innerhalb der Praxisgruppe.
          </div>
        </div>

        <button
          onClick={() => setShowQueueModal(false)}
          style={{
            border: "1px solid rgba(15,23,42,0.10)",
            background: "#eef2ff",
            color: "#1f2937",
            borderRadius: 10,
            padding: "8px 12px",
            fontWeight: 800,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          ✕ Schließen
        </button>
      </div>

      {/* BODY */}
      <div style={{ padding: 18 }}>
        {queueLoading && (
          <div
            style={{
              padding: 12,
              borderRadius: 12,
              background: "rgba(15,23,42,0.04)",
              border: "1px solid rgba(15,23,42,0.06)",
              fontSize: 14,
              color: "rgba(15,23,42,0.8)",
            }}
          >
            Lade…
          </div>
        )}

        {queueError && (
          <div
            style={{
              padding: 12,
              borderRadius: 12,
              background: "rgba(239, 68, 68, 0.08)",
              border: "1px solid rgba(239, 68, 68, 0.18)",
              fontSize: 14,
              color: "#991b1b",
            }}
          >
            {queueError}
          </div>
        )}

        {!queueLoading && !queueError && (
          queuePatients.length === 0 ? (
            <div
              style={{
                padding: 12,
                borderRadius: 12,
                background: "rgba(15,23,42,0.04)",
                border: "1px solid rgba(15,23,42,0.06)",
                fontSize: 14,
                color: "rgba(15,23,42,0.75)",
              }}
            >
              Keine Patienten in der Warteliste.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* ONE HEADER ROW (like ❓ modal) */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.1fr 1fr 1.1fr 1.1fr 0.6fr",
                  gap: 12,
                  padding: "10px 14px",
                  borderRadius: 12,
                  background: "rgba(15,23,42,0.04)",
                  border: "1px solid rgba(15, 23, 42, 0.06)",
                  fontSize: 11,
                  fontWeight: 900,
                  color: "rgba(0, 0, 0, 1)",
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                }}
              >
                <div>Patient</div>
                <div>Terminart</div>
                <div>Arzt/Therapeut</div>
                <div>Vergebener Termin</div>
                <div style={{ textAlign: "center" }}>Aktionen</div>
              </div>

              {/* ROWS (no per-card labels) */}
              {queuePatients.map((p) => (
                <div
                  key={p.id || p.patient_id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1.1fr 1fr 1.1fr 1.1fr 0.6fr",
                    gap: 12,
                    alignItems: "center",
                    padding: 14,
                    borderRadius: 14,
                    background: "rgba(255,255,255,0.92)",
                    border: "1px solid rgba(15, 23, 42, 0.08)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ fontSize: 14, color: "#0f172a" }}>
                    {p.name || "-"}
                  </div>

                  <div style={{ fontSize: 14, color: "rgba(15,23,42,0.85)" }}>
                    {p.terminart || "-"}
                  </div>

                  <div style={{ fontSize: 14, color: "rgba(15,23,42,0.85)" }}>
                    {p.doctor_name || p.doctor_id || "-"}
                  </div>

                  <div style={{ fontSize: 14, color: "rgba(15,23,42,0.85)" }}>
                    {p.original_termin || "-"}
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <button
                      onClick={() => {
                        setDeleteTargetPatient(p);
                        setShowQueueDeleteModal(true);
                      }}
                
                   
                     style={{
                        width: 36,
                        height: 36,
                        borderRadius: 12,
                        border: "1px solid rgba(185,28,28,0.18)",
                        background: "rgba(185,28,28,0.10)",
                        color: "#b91c1c",
                        fontWeight: 900,
                        cursor: "pointer",
                        boxShadow: "0 6px 16px rgba(185,28,28,0.10)",
                      }}
                      title="Patient löschen"
                    >
                      ❌
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  </div>
)}









{toast && (
  <div style={{
    position: "fixed",
    top: 28,
    left: "50%",
    transform: "translateX(-50%)",
    background: "#345A46",
    color: "#fff",
    padding: "14px 28px",
    borderRadius: 14,
    fontWeight: 600,
    fontSize: 17,
    boxShadow: "0 4px 18px rgba(0,0,0,0.15)",
    zIndex: 99999,
    opacity: 0.98,
    transition: "opacity 0.3s"
  }}>
    {toast}
  </div>
)}





    <div style={{
      display: 'flex',
      flexDirection: 'row',
      minHeight: '100vh',
      background: '#f3f4f6',
      padding: '24px'
    }}>

     {/* --- SIDEBAR COLUMN START --- */}
<div style={{ display: 'flex', flexDirection: 'column', marginRight: 18 }}>
  {/* Puzzle Care branding */}
  <div style={{
    width: 173,
    minWidth: 120,
    background: '#5a55f4',
    color: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    padding: '8px 0',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 19,
      fontFamily: "'DM Sans', sans-serif",
    marginBottom: 18,
    letterSpacing: 1,
  }}>
    PUZZLE CARE
  </div>
  {/* Your Terminarten sidebar */}
  <div
    ref={externalEventsRef}
    id="external-events"
    style={{
      position: "sticky",
      top: 0,
      alignSelf: "flex-start",
      width: 150,
      minWidth: 120,
      background: 'white',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      padding: '14px 12px',
                  border: '1px solid #5a55f4', // <--  border color

      height: 'fit-content',
      zIndex: 10
    }}
  >
    <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 10, textAlign: 'center' }}> Terminarten</div>
    {sidebarEvents.map(ev => (
      <div
        key={ev.title + ev.duration + ev.color}
        className="fc-event"
        data-title={ev.title}
        data-color={ev.color}
        data-duration={ev.duration}
        style={{
          background: ev.color,
          color: '#fff',
          padding: '7px 2px',
          borderRadius: 6,
          marginBottom: 9,
          cursor: 'move',
          textAlign: 'center',
          fontSize: 13,
          lineHeight: 1.1,
        }}
      >
        {ev.title}
        <div style={{ fontSize: 9, opacity: 0.8 }}>
          Dauer: {ev.duration} Min
        </div>
      </div>
    ))}
  </div>
</div>
{/* --- SIDEBAR COLUMN END --- */}

      <div style={{
        flex: 1,
        minWidth: 0,
        background: 'white',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        padding: 24
      }}>

<FullCalendar
  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
  initialView="timeGridWeek"
 headerToolbar={{
  left: 'prev,next today warteliste',
  center: 'title',
  right: 'reminderPatients anfragen practiceAvail queuePatients dayGridMonth,timeGridWeek,timeGridDay'
}}

  
customButtons={{
  warteliste: {
    text: '⌛️',
    click: () => setShowManualModalWarteliste(true),
  },
  queuePatients: {
    text: '🤒',
    click: openQueueModal,
  },
  practiceAvail: {
    text: '📋',
    click: openPracticeAvailModal,
  },
  reminderPatients: {
  text: '⏰',
  click: openReminderModal,
},
  anfragen: {
  text: '❓',
  click: openAnfragenModal,
},
}}


  

          locales={[deLocale]}
          locale="de"
          eventDidMount={info => {
            const status = info.event.extendedProps.status;
            const eventColor = (
              status === "matched"
                ? "#7F7F7F"
                : status === "confirmed"
                  ? "#345A46"
                  : info.event.backgroundColor || "#2563eb"
            );
            info.el.style.color = "#fff";
            const innerEls = info.el.querySelectorAll('.fc-event-main, .fc-event-title, .fc-event-title-container');
            innerEls.forEach(inner => {
              inner.style.background = "transparent";
              inner.style.backgroundColor = "transparent";
              inner.style.color = "#fff";
            });
            info.el.addEventListener('dblclick', () => {
              console.log("DOUBLE CLICK on event", info.event);
              handleEventDoubleClick(info);
            });
          }}
          firstDay={1}
          editable={true}
          selectable={true}
          select={handleDateSelect}
          droppable={true}
          eventResize={handleEventResize}
          eventChange={handleEventChange}
          eventReceive={handleEventReceive}
          events={events}
          eventContent={renderEventContent}
          eventClick={handleEventClick}
          height="auto"
          slotMinTime="07:00:00"
          slotMaxTime="20:00:00"
          allDaySlot={false}
          slotDuration="00:05:00"
          snapDuration="00:05:00"
          slotLabelInterval="00:30:00"
        />
      </div>
    </div>
  </>
);
}

